<template>
  <div>
    <!-- 服务商 -->
    <div class="detail-wrap">
      <el-form ref="editForm" :model="tenant">
        <div class="d-header">
          <div class="fl">
            <i class="el-icon-info" />
            <!-- {{ dataId ? '查看' : '新增' }}工单 -->
            工单号：<span style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{ formData.orderNo }}</span>
            <!-- 服务类型 -->
            <span class="information">{{ formData.serverTypeName }}</span>
            <!-- 工单状态 -->
            <span class="information" v-if="formData.stat == 1">登记</span>
            <span class="information" v-else-if="formData.stat == 2">发布</span>
            <span class="information" v-else-if="formData.stat == 5">已派网点</span>
            <span class="information" v-else-if="formData.stat == 6">网点已接单</span>
            <span class="information" v-else-if="formData.stat == 9">已派师傅</span>
            <span class="information" v-else-if="formData.stat == 10">师傅已接单</span>
            <span class="information" v-else-if="formData.stat == 11">已预约</span>
            <span class="information" v-else-if="formData.stat == 13">已出发</span>
            <span class="information" v-else-if="formData.stat == 17">已上门</span>
            <span class="information" v-else-if="formData.stat == 20">完工暂存</span>
            <span class="information" v-else-if="formData.stat == 30">寄修待确认</span>
            <span class="information" v-else-if="formData.stat == 31">待寄件</span>
            <span class="information" v-else-if="formData.stat == 32">已寄待签收</span>
            <span class="information" v-else-if="formData.stat == 36">待维修</span>
            <span class="information" v-else-if="formData.stat == 37">修好待寄出</span>
            <span class="information" v-else-if="formData.stat == 38">客户待签收</span>
            <span class="information" v-else-if="formData.stat == 40">退换待确认</span>
            <span class="information" v-else-if="formData.stat == 41">旧机待退回</span>
            <span class="information" v-else-if="formData.stat == 42">旧机待签收</span>
            <span class="information" v-else-if="formData.stat == 43">旧机已签收</span>
            <span class="information" v-else-if="formData.stat == 44">新机待寄出</span>
            <span class="information" v-else-if="formData.stat == 45">新机已寄出</span>
            <span class="information" v-else-if="formData.stat == 47">新机待签收</span>
            <span class="information" v-else-if="formData.stat == 48">新机已签收</span>
            <span class="information" v-else-if="formData.stat == 49">退换被驳回</span>
            <span class="information" v-else-if="formData.stat == 61">已完工</span>
            <span class="information" v-else-if="formData.stat == 62">网点确认完工</span>
            <span class="information" v-else-if="formData.stat == 63">中心完工审核</span>
            <span class="information" v-else-if="formData.stat == 64">总部完工审核</span>
            <span class="information" v-else-if="formData.stat == 91">待结算</span>
            <span class="information" v-else-if="formData.stat == 92">结算驳回</span>
            <span class="information" v-else-if="formData.stat == 93">结算中止</span>
            <span class="information" v-else-if="formData.stat == 94">已结算</span>
            <span class="information" v-else-if="formData.stat == 97">申请关闭</span>
            <span class="information" v-else-if="formData.stat == 98">挂起</span>
            <span class="information" v-else-if="formData.stat == 99">取消</span>
            <span class="information" v-else-if="formData.stat == 100">结束</span>
            <span class="information" v-else></span>

            <!-- 紧急度 -->
            <span class="information" v-if="formData.urger == 0">一般</span>
            <span class="information" v-else-if="formData.urger == 1">紧急</span>
            <span class="information" v-else-if="formData.urger == 2">特急</span>
            <span class="information" v-else>未知</span>


          </div>
          <div v-if="pageType === '投诉处理'">

          </div>
          <div v-else-if="pageType === '电商平台'"></div>
          <div style="" v-else>

          </div>
        </div>

        <div>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="工单详情" name="first">
              <!-- 基本信息 -->
              <dix style="display: flex;  overflow: unset!important;
    overflow-y: scroll!important;
    height: 100vh!important; ">
                <div class="d-cont edit-mce-box" style="width: 80%;">
                  <div class="d-item" style="padding-top: 10px;">
                    <!-- <div class="title first"><b>受理信息</b></div> -->
                    <table class="table-detail">
                      <tbody>

                      <tr>
                        <th>姓名</th>
                        <td>{{ formData.userName }}</td>
                        <th>来电号码</th>
                        <td>{{ formData.userMobile }}</td>
                        <th>用户类型</th>
                        <td v-if="formData.userType == 0">普通用户</td>
                        <td v-if="formData.userType == 1">售前机</td>
                        <td v-if="formData.userType == 2">工程机</td>
                        <td v-if="formData.userType == 3">VIP用户</td>
                        <td v-if="formData.userType == 4">经销商</td>

                        <th>用户档案号</th>
                        <td>{{ formData.profileNo }}</td>

                      </tr>
                      <tr>
                        <!-- <th>用户单位</th>
                      <td>{{ formData.outOrderNo }}</td>
                      <th>合同号</th>
                      <td>{{ formData.outOrderNo }}</td> -->

                      </tr>
                      <tr>
                        <th>用户地址</th>
                        <td  colspan="7">
                          {{ formData.userProvice }}{{ formData.userCity }}{{
                            formData.userCounty
                          }}{{ formData.userTown }}{{ formData.userAddress }}
                        </td>
                      </tr>
                      <tr>
                        <th>
                          服务类型
                        </th>
                        <td>
                          {{ formData.serverTypeName }}
                        </td>
                        <th>保修类型</th>
                        <td v-if="formData.guaranteeType == 1"><span class="btn_t">保内</span></td>
                        <td v-else-if="formData.guaranteeType == 2"><span class="btn_f">保外</span></td>
                        <td v-else-if="formData.guaranteeType == 3"><span class="btn_f">未知</span></td>
                        <td v-else></td>


                        <th>工单来源</th>
                        <td>{{ formData.orderTypeName }}</td>
                        <!-- <th>客诉类型</th>
                      <td>{{ formData.complaintTypeName }}</td> -->
                        <th>督办人</th>
                        <td>{{ formData.managerName }}</td>
                      </tr>
                      <tr>
                        <th>录单故障</th>
                        <td>{{ formData.issueFaultName }}</td>
                        <th>外部订单号</th>
                        <td>{{ formData.outOrderNo }}</td>
                        <!-- <th>购买时间</th>
                      <td>{{ formData.buyDate }}</td>
                      <th>购买商场</th>
                      <td>{{ formData.buyShop }}</td> -->
                        <th>工单标签</th>
                        <td>{{ formData.dispatchStat }}</td>

                        <th>购买渠道</th>
                        <td>{{ formData.buyChannelName }}</td>
                      </tr>
                      <tr>

                        <th>回访状态</th>
                        <td v-if="formData.recallStat == 0"><span class="btn_f">未回访</span></td>
                        <td v-if="formData.recallStat == 1"><span class="btn_t">已抽样</span></td>
                        <td v-if="formData.recallStat == 2"><span class="btn_t">已回访</span></td>
                        <td v-if="formData.recallStat == 5"><span class="btn_t">用户已评价</span></td>


                        <th>申诉状态</th>
                        <td v-if="formData.siteComplainStat == 0"><span class="btn_t">无申诉</span></td>
                        <td v-if="formData.siteComplainStat == 3"><span class="btn_t">待申诉</span></td>
                        <td v-if="formData.siteComplainStat == 5"><span class="btn_t">已申诉</span></td>
                        <td v-if="formData.siteComplainStat == 7"><span class="btn_t">中心已审核</span></td>
                        <td v-if="formData.siteComplainStat == 8"><span class="btn_f">中心驳回</span></td>
                        <td v-if="formData.siteComplainStat == 9"><span class="btn_t">总部已处理</span></td>
                        <td v-if="formData.siteComplainStat == 99"><span class="btn_f">取消</span></td>

                        <th>质检状态</th>
                        <td v-if="formData.qualityStat == 0"><span class="btn_t">无需质检</span></td>
                        <td v-else-if="formData.qualityStat == 1"><span class="btn_f">待质检</span></td>
                        <td v-else-if="formData.qualityStat == 2"><span class="btn_t">质检通过</span></td>
                        <td v-else-if="formData.qualityStat == 3"><span class="btn_f">质检不通过</span></td>
                        <td v-else></td>
                        <th>配件状态</th>
                        <td v-if="formData.partsStat == 0"><span class="btn_t">无配件</span></td>
                        <td v-if="formData.partsStat == 1"><span class="btn_t">申请</span></td>
                        <td v-if="formData.partsStat == 2"><span class="btn_t">审核</span></td>
                        <td v-if="formData.partsStat == 3"><span class="btn_t">出库</span></td>
                        <td v-if="formData.partsStat == 4"><span class="btn_t">网点收货</span></td>
                        <td v-if="formData.partsStat == 8"><span class="btn_f">驳回</span></td>
                        <td v-if="formData.partsStat == 9"><span class="btn_f">取消</span></td>
                        <td v-if="formData.partsStat == 11"><span class="btn_t">更换</span></td>
                        <td v-if="formData.partsStat == 12"><span class="btn_t">网点返厂</span></td>
                        <td v-if="formData.partsStat == 13"><span class="btn_t">返厂确认</span></td>
                      </tr>
                      <!-- <tr>

                      <th>发票号</th>
                      <td>{{ formData.invoiceNo }}</td>

                      <th>报单条码</th>
                      <td>{{ formData.brarcode }}</td>
                      <th>质检状态</th>
                      <td v-if="formData.qualityStat==0"><span class="btn_f">未质检</span></td>
                      <td v-if="formData.qualityStat==1"><span class="btn_f">质检通过</span></td>
                      <td v-if="formData.qualityStat==2"><span class="btn_f">质检不通过</span></td>
                    </tr> -->


                      <tr >


                        <th>述求</th>
                        <td colspan="7">{{ formData.appeals }}
                        </td>
                      </tr>

                      <tr>

                      </tr>


                      </tbody>
                    </table>
                  </div>
                  <div class="d-item" style="padding-top: 10px;">
                    <!-- <div class="title first"><b>受理信息</b></div> -->
                    <table class="table-detail">
                      <tbody>

                      <tr>
                        <th>机构名称</th>
                        <td>{{ formData.orgName }}</td>
                        <th>一级服务商</th>
                        <td>{{ formData.bigSiteName }}</td>
                        <th>网点名称</th>
                        <td>{{ formData.siteName }}</td>
                        <th>工程师名称</th>
                        <td>{{ formData.engineerName }}</td>
                        <!-- <th>督办人</th>
                      <td>{{ formData.engineerName }}</td> -->
                      </tr>
                      <tr>

                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-- 集合 -->

                  <div class="d-item" style="margin-top: 10px;">
                    <table class="table-detail" style="width: 100%;">
                      <tbody style="width: 100%;">
                      <template>
                        <el-tabs v-model="activeName2" style="width: 100%;" class="gather">
                          <el-tab-pane label="节点图" name="first">
                            <div style="margin-top: 10px;">
                              <!--                                <el-steps :active="2" align-center finish-status="success" style="margin-bottom: 10px;">
                                                                <el-step title="发布工单" description="2022-10-12 12:00"></el-step>
                                                                <el-step title="派工到人" description="2022-10-13 09:00"></el-step>
                                                                <el-step title="首约" description="2022-10-14 10:00"></el-step>
                                                                <el-step title="终约" description="2022-10-15 11:00"></el-step>
                                                                &lt;!&ndash; <el-step title="上门签到" description="2022-10-12 12:00"></el-step> &ndash;&gt;
                                                                <el-step title="申请配件" description="2022-10-16 12:00"></el-step>
                                                                <el-step title="上门签到" description="2022-10-17 10:00"></el-step>
                                                                <el-step title="完工" description="2022-10-18 11:00"></el-step>
                                                                <el-step title="用户评价" description="2022-10-19 12:00"></el-step>
                                                                <el-step title="结算申请" description="2022-10-20 12:00"></el-step>

                                                              </el-steps>-->
                              <tr style="margin-top: 10px;">
                                <th>创建时间</th>
                                <td>{{ formData.createTime }}</td>

                                <th>派中心时间</th>
                                <td>{{ formData.soOrderProcessDTO.takeOrgTime }}</td>

                                <th>派单时间</th>
                                <td>{{ formData.takeTime }}</td>

                                <th>网点确认接单时间</th>
                                <td>{{ formData.soOrderProcessDTO.acceptOperateTime }}</td>

                                <th>派工程师时间</th>
                                <td>{{ formData.takeEngineerTime }}</td>
                              </tr>
                              <tr>
                                <th>
                                  工程师确认接单时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.engineerAcceptOperateTime }}
                                </td>
                                <th>
                                  首次预约操作时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.firstBookOperateTime }}
                                </td>
                                <th>
                                  首次预约时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.firstBookDate }}
                                </td>
                                <th>
                                  预约操作时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.bookOperateTime }}
                                </td>
                              </tr>
                              <tr>
                                <th>
                                  预约时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.bookDate }}
                                </td>
                                <th>
                                  预约次数
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.bookTimes }}
                                </td>
                                <th>
                                  出发时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.startOffTime }}
                                </td>
                                <th>
                                  上门签到时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.onDoorTime }}
                                </td>
                              </tr>
                              <tr>
                                <th>
                                  上门签到地址
                                </th>
                                <td colspan="">
                                  {{ formData.soOrderProcessDTO.onDoorLocation }}
                                </td>
                                <th>
                                  首次完工时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.firstCompleteTime }}
                                </td>
                                <th>
                                  完工时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.completeTime }}
                                </td>
                                <th>
                                  完工地址
                                </th>
                                <td colspan="">
                                  {{ formData.soOrderProcessDTO.onTimeLocation }}
                                </td>
                              </tr>
                              <tr>
                                <th>
                                  网点确认完工时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.siteComfirmTime }}
                                </td>
                                <th>
                                  中心确认完工时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.orgComfirmTime }}
                                </td>
                                <th>
                                  总部确认完工时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.officeComfirmTime }}
                                </td>
                                <th>
                                  回访时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.recallTime }}
                                </td>
                              </tr>
                              <tr>
                                <th>
                                  客诉跟进次数
                                </th>
                                <td colspan="">
                                  {{ formData.soOrderProcessDTO.complaintProcessTimes }}
                                </td>
                                <th>
                                  客诉跟进人
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.complaintProcesser }}
                                </td>
                                <th>
                                  客诉跟进时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.complaintProcessDate }}
                                </td>
                                <th>
                                  网点客诉跟进时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.siteComplaintProcessDate }}
                                </td>
                              </tr>
                              <tr>
                                <th>
                                  进入结算池时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.applyPayDate }}
                                </td>
                                <th>
                                  提交结算时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.payDate }}
                                </td>
                                <th>
                                  取消/退单时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.cancleDate }}
                                </td>
                                <th>
                                  取消/退单原因
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.returnName }}
                                  <!--                            <el-input type="text" autocomplete="off" v-model="tenant.orgName" clearable/>-->
                                </td>
                                <!-- <th>
                                完工备注
                              </th>
                              <td>
                                {{ formData.soOrderProcessDTO.finishNote }}
                              </td> -->
                              </tr>
                              <tr>
                                <th>维修状态</th>
                                <td v-if="formData.soOrderProcessDTO.fixStatus == 1"><span class="btn_t">正常维修</span>
                                </td>
                                <td v-else-if="formData.soOrderProcessDTO.fixStatus == 2"><span class="btn_f">退机</span>
                                </td>
                                <td v-else-if="formData.soOrderProcessDTO.fixStatus == 3"><span class="btn_f">退换机</span>
                                </td>
                                <td v-else></td>
                                <th>
                                  完工审核备注
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.comfirmNote }}
                                </td>
                                <th>
                                  改约时间
                                </th>
                                <td>
                                  {{formData.soOrderProcessDTO.bookDate}} {{ formData.soOrderProcessDTO.bookDatePeriod }}
                                </td>
                                <th>
                                  改约原因
                                </th>
                                <td>
                                  <dict-value-show :id="formData.soOrderProcessDTO.changeBookReason"/>
                                  <!--                                    {{ formData.soOrderProcessDTO.changeBookReasonName }}-->
                                </td>
                              </tr>
                            </div>
                          </el-tab-pane>
                          <el-tab-pane label="考核单" name="third-1" class="product">
                            <div class="product" style="">
                              <vxe-table ref="filterTable" :data="formData.sfCheckBillDTOList" class="table_item"
                                         style="margin: 12px auto; width: 95%;" :stripe="true"
                                         :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                                         :row-config="{ height: 30, isHover: true, padding: 0, }"
                                         :row-style="{ fontSize: '12px', }" show-overflow height="100"
                                         :column-config="{ resizable: true }">
                                <!--                        <vxe-column type="selection" width="55">-->
                                <!--                        </vxe-column>-->
                                <vxe-column field="billNo" title="考核单号" width="120" />
                                <!--                                <vxe-column field="siteName" title="网点名称" width="70"/>-->
                                <vxe-column field="stat" title="状态" width="70" />
                                <vxe-column field="orgName" title="服务中心" width="70" />
                                <vxe-column field="siteName" title="服务商名称" width="110" />
                                <vxe-column field="amount" title="考核类别" width="70" />
                                <vxe-column field="standardAmount" title="考核金额" width="70" />
                                <vxe-column field="adjustAmount" title="调整金额" width="70" />
                                <vxe-column field="amount" title="合计金额" width="70" />
                                <vxe-column field="checkAmount" title="审批金额" width="70" />
                                <!-- <vxe-column field="createBy" title="创建人" width="70"/>
                              <vxe-column field="createTime" title="创建时间" width="120"/> -->
                              </vxe-table>
                            </div>
                          </el-tab-pane>
                          <el-tab-pane label="客诉&咨询" name="second">
                            <tr>
                              <p class="title_p">投诉信息</p>
                            </tr>
                            <tr>
                              <th>投诉对象</th>
                              <td>{{ formData.soOrderExtendDTO.complaintObjectName }}</td>

                              <th>投诉性质</th>
                              <td>
                                {{ formData.soOrderExtendDTO.complaintPropertyName }}
                              </td>

                              <th>是否内部转单</th>
                              <td v-if="formData.soOrderExtendDTO.isIntransfer == 0"><span class="btn_f">否</span></td>
                              <td v-else-if="formData.soOrderExtendDTO.isIntransfer == 1"><span class="btn_t">是</span>
                              </td>
                              <td v-else></td>

                              <th>投诉处理满意</th>
                              <td v-if="formData.soOrderExtendDTO.dealSatisfaction == 0"><span class="btn_f">否</span>
                              </td>
                              <td v-else-if="formData.soOrderExtendDTO.dealSatisfaction == 1"><span
                                class="btn_t">是</span>
                              </td>
                              <td v-else></td>
                            </tr>
                            <tr>
                              <th>责任判定</th>
                              <td>
                                <!--                                  <dict-value-show :id="formData.soOrderExtendDTO.dutyJudgeName" />-->
                                {{ formData.soOrderExtendDTO.dutyJudgeName }}
                              </td>

                              <th>责任细分</th>
                              <td>
                                <!--                                  <dict-value-show :id="formData.soOrderExtendDTO.dutyJudgeSubName" />-->
                                {{ formData.soOrderExtendDTO.dutyJudgeSubName }}
                              </td>

                              <th>处理方式</th>
                              <td>
                                <!--                                  <dict-value-show :id="formData.soOrderExtendDTO.handleModelName" />-->
                                {{ formData.soOrderExtendDTO.handleModelName }}
                              </td>

                            </tr>
                            <tr>
                              <th>
                                处理方案
                              </th>
                              <td colspan="7">
                                {{ formData.soOrderExtendDTO.handlePlan }}
                              </td>
                            </tr>
                            <tr>
                              <p class="title_p">咨询与表扬</p>
                            </tr>

                            <tr>
                              <th>表扬对象</th>
                              <td>
                                {{ formData.soOrderExtendDTO.praiseObjectName }}
                              </td>
                              <th>表扬类型</th>
                              <td>
                                {{ formData.soOrderExtendDTO.praiseTypeName }}
                              </td>
                              <th>表扬是否成立</th>
                              <td v-if="formData.soOrderExtendDTO.praiseJudge == 0"><span class="btn_f">否</span></td>
                              <td v-else-if="formData.soOrderExtendDTO.praiseJudge == 1"><span class="btn_t">是</span>
                              </td>
                              <td v-else></td>
                              <th>奖励是否成立</th>
                              <td v-if="formData.soOrderExtendDTO.rewardJudge == 0"><span class="btn_f">否</span></td>
                              <td v-else-if="formData.soOrderExtendDTO.rewardJudge == 1"><span class="btn_t">是</span>
                              </td>
                              <td v-else></td>
                            </tr>
                            <tr>
                              <th>咨询类型</th>
                              <td>
                                <!--                                  <dict-value-show :id="formData.soOrderExtendDTO.consultType" />-->
                                {{ formData.soOrderExtendDTO.consultTypeName }}
                              </td>

                              <th>咨询细分</th>
                              <td>
                                <!--                                  <dict-value-show :id="formData.soOrderExtendDTO.consultTypeSub" />-->
                                {{ formData.soOrderExtendDTO.consultTypeSubName }}
                              </td>
                            </tr>


                          </el-tab-pane>
                          <el-tab-pane label="产品信息" name="third" class="product">
                            <div class="product" style="">
                              <vxe-table ref="filterTable" :data="formData.soOrderLineDTOList" class="table_item"
                                         style="margin:12px auto; width: 95%;" :stripe="true"
                                         :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                                         :row-config="{ height: 30, isHover: true, padding: 0, }"
                                         :row-style="{ fontSize: '12px', }" show-overflow height="100"
                                         :column-config="{ resizable: true }">
                                <vxe-column type="seq" width="30">
                                </vxe-column>

                                <vxe-column field="itemCode" title="产品编码">
                                </vxe-column>
                                <vxe-column field="itemName" title="产品名称" />
                                <vxe-column field="bigCategoryName" title="产品大类名称" />
                                <vxe-column field="smallCategoryName" title="产品小类名称" />

                                <vxe-column field="buyShop" title="购买商场" />
                                <vxe-column field="buyDate" title="购买时间" />

                                <vxe-column field="barcode" title="条码">
                                </vxe-column>
                                <vxe-column field="qty" title="数量" width="80">
                                </vxe-column>
                                <vxe-column field="sitePrice" title="服务费单价" width="80" />
                                <vxe-column field="siteFee" title="服务费" width="80" />
                              </vxe-table>
                            </div>
                          </el-tab-pane>
                          <el-tab-pane label="关联单据" name="fourth">
                            <div class="product" style="">
                              <vxe-table ref="filterTable" :data="formData.associateDocuments" class="table_item"
                                         style="margin: 12px auto; width: 95%;" :stripe="true"
                                         :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                                         :row-config="{ height: 30, isHover: true, padding: 0, }"
                                         :row-style="{ fontSize: '12px', }"
                                         show-overflow height="250"
                                         :column-config="{ resizable: true }">
                                <vxe-column field="type" title="单据类型" width="120" />
                                <vxe-column field="documentNumber" title="单据号" width="200">
                                  <template #default="{row}">
                                    <span style="cursor: pointer; color: blue" @click="openDocumentNumber(row.type, row.id,row)">{{row.documentNumber}}</span>
                                  </template>
                                </vxe-column>
                                <vxe-column field="statName" title="状态" width="100" />
                                <vxe-column field="createTime" title="创建时间" width="150" />
                                <vxe-column field="createBy" title="创建人" width="150" />
                              </vxe-table>
                            </div>
                            <!-- <tr>
                              <th style="position: absolute;top: 34px;">上门签到</th>
                              <div style="display: flex;position: absolute;left:8vw;top:10px;">
                                <el-image v-if="formData.pic1" :preview-src-list="picList" fit="fit"
                                  :src="formData.pic1" :initial-index="0"></el-image>
                                <el-image v-else>
                                  <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"
                                      style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                                  </div>
                                </el-image>

                              </div>

                            </tr> -->
                            <!-- <tr>
                              <th style="position: absolute;top: 124px;">现场照片</th>
                              <div style="display: flex;position: absolute;left:8vw;top:100px;">
                                <el-image v-if="formData.pic1" :preview-src-list="picList" fit="fit"
                                  :src="formData.pic1" :initial-index="0"></el-image>
                                <el-image v-else>
                                  <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"
                                      style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                                  </div>
                                </el-image>

                              </div>

                            </tr>
                            <tr>
                              <th style="position: absolute;top: 214px;">修复照片</th>
                              <div style="display: flex;position: absolute;left:8vw;top:190px;">
                                <el-image v-if="formData.pic1" :preview-src-list="picList" fit="fit"
                                  :src="formData.pic1" :initial-index="0"></el-image>
                                <el-image v-else>
                                  <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"
                                      style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                                  </div>
                                </el-image>

                              </div>

                            </tr> -->
                          </el-tab-pane>
                          <el-tab-pane label="业务信息" name="five">
                            <tr>
                              <th>是否必访</th>
                              <td v-if="formData.isMustRecall == 0"><span class="btn_f">否</span></td>
                              <td v-else-if="formData.isMustRecall == 1"><span class="btn_t">是</span></td>
                              <td v-else></td>

                              <th>是否可抽样</th>
                              <td v-if="formData.isCallRecall == 0"><span class="btn_f">否</span></td>
                              <td v-else-if="formData.isCallRecall == 1"><span class="btn_t">是</span></td>
                              <td v-else></td>

                              <th>是否急单</th>
                              <td v-if="formData.isUrgent == 0"><span class="btn_f">否</span></td>
                              <td v-else-if="formData.isUrgent == 1"><span class="btn_t">是</span></td>
                              <td v-else></td>

                              <th>是否重新完工</th>
                              <td v-if="formData.isReplaceFinish == 0"><span class="btn_f">否</span></td>
                              <td v-else-if="formData.isReplaceFinish == 1"><span class="btn_t">是</span></td>
                              <td v-else></td>


                            </tr>
                            <tr>
                              <th>催单次数</th>
                              <td>{{ formData.urgeTimes }}</td>

                              <th>投诉次数</th>
                              <td>{{ formData.complainTimes }}</td>

                              <th>结算单</th>
                              <td>
                                {{ formData.settleName }}
                              </td>
                              <th>
                                sendPay打标标识
                              </th>
                              <td>
                                {{ formData.sendPay }}
                              </td>
                            </tr>
                            <tr>
                              <th>受理ID</th>
                              <td>{{ formData.caseId }}</td>

                              <th>父工单号</th>
                              <td>{{ formData.parentOrderNo }}</td>

                              <th>完工模式</th>
                              <td v-if="formData.soOrderExtendDTO.finishMode == 1">结算密码</td>
                              <td v-if="formData.soOrderExtendDTO.finishMode == 2">上传图片</td>
                              <td v-if="formData.soOrderExtendDTO.finishMode == 3">图片+条码</td>
                              <td v-if="formData.soOrderExtendDTO.finishMode == 9">无验证完工</td>
                              <td v-if="formData.soOrderExtendDTO.finishMode == null"></td>


                              <th>完工方式</th>
                              <td v-if="formData.soOrderExtendDTO.finishType == 1">总部代完工</td>
                              <td v-if="formData.soOrderExtendDTO.finishType == 2">网点PC端完工</td>
                              <td v-if="formData.soOrderExtendDTO.finishType == 3">网点APP完工</td>
                              <td v-if="formData.soOrderExtendDTO.finishType == 4">师傅APP完工</td>
                              <td v-if="formData.soOrderExtendDTO.finishType == 5">接口完工</td>
                              <td v-if="formData.soOrderExtendDTO.finishType == 9">其他</td>
                              <td v-if="formData.soOrderExtendDTO.finishType == null"></td>

                            </tr>
                            <tr>
                              <th>质检人</th>
                              <td>{{ formData.soOrderExtendDTO.qualityMan }}</td>

                              <th>质检时间</th>
                              <td>{{ formData.soOrderExtendDTO.qualityDate }}</td>

                              <!-- <th>短信满意度</th>
                            <td v-if="formData.soOrderExtendDTO.commentLevel==1">非常满意</td>
                            <td v-if="formData.soOrderExtendDTO.commentLevel==2">满意</td>
                            <td v-if="formData.soOrderExtendDTO.commentLevel==3">一般</td>
                            <td v-if="formData.soOrderExtendDTO.commentLevel==4">不满意</td>
                            <td v-if="formData.soOrderExtendDTO.commentLevel==5">非常不满意</td>
                            <td
                              v-if="formData.soOrderExtendDTO.commentLevel==0 || formData.soOrderExtendDTO.commentLevel==null">
                            </td> -->
                              <th>服务卡号</th>
                              <td>{{ formData.soOrderExtendDTO.serviceCardNo }}</td>
                              <th>是否已发送评价短信</th>
                              <td v-if="formData.soOrderExtendDTO.isSendCommentMessage == 0">
                                <span class="btn_f">否</span>
                              </td>
                              <td v-if="formData.soOrderExtendDTO.isSendCommentMessage == 1">
                                <span class="btn_t">是</span>
                              </td>
                              <td v-if="formData.soOrderExtendDTO.isSendCommentMessage == null"></td>

                            </tr>
                            <tr>
                              <th>质检不通过原因</th>
                              <td>{{ formData.soOrderExtendDTO.qualityRemark }}</td>

                              <th>是否二次申诉</th>
                              <td v-if="formData.soOrderExtendDTO.secondSiteComplain == 0"><span class="btn_f">否</span>
                              </td>
                              <td v-if="formData.soOrderExtendDTO.secondSiteComplain == 1"><span class="btn_t">是</span>
                              </td>
                              <td v-if="formData.soOrderExtendDTO.secondSiteComplain == null"></td>

                              <th>是否送装同步</th>
                              <td v-if="formData.soOrderExtendDTO.isInstallSynchro == 0"><span class="btn_f">否</span>
                              </td>
                              <td v-if="formData.soOrderExtendDTO.isInstallSynchro == 1"><span class="btn_t">是</span>
                              </td>
                              <td v-if="formData.soOrderExtendDTO.isInstallSynchro == null"></td>

                              <th>是否空白市场</th>
                              <td v-if="formData.soOrderExtendDTO.blankMarket == 0"><span class="btn_f">否</span></td>
                              <td v-if="formData.soOrderExtendDTO.blankMarket == 1"><span class="btn_t">是</span></td>
                              <td v-if="formData.soOrderExtendDTO.blankMarket == null"></td>
                            </tr>
                            <tr>
                              <th>期望上门/安装时间</th>
                              <td>{{ formData.wishBookDate }} {{ formData.wishBookPeriod }}</td>

                              <th>到货签收时间</th>
                              <td>{{ formData.soOrderExtendDTO.deliverTime }}</td>
                              <th>京东预计送达日期</th>
                              <td>{{ formData.soOrderExtendDTO.jdEstimatedDeliveryDate }}</td>

                              <th>京东预约安装日期</th>
                              <td>{{ formData.soOrderExtendDTO.jdAppointmentInstallDate }}</td>
                            </tr>
                            <tr>
                              <th>挂起类型</th>
                              <td v-if="formData.soOrderExtendDTO.hangupType == 0">总部挂起</td>
                              <td v-if="formData.soOrderExtendDTO.hangupType == 1">网点挂起</td>
                              <td v-if="formData.soOrderExtendDTO.hangupType == null"></td>
                              <th>挂起原因</th>
                              <td>{{ formData.soOrderExtendDTO.hangupReason }}</td>
                              <th>创建人工号</th>
                              <td>{{ formData.createrNumber }}</td>
                              <th>地址编码</th>
                              <td>{{ formData.addressNumber }}</td>
                            </tr>
                            <tr>
                              <th>增值服务项</th>
                              <td>
                                <dict-value-show :id="formData.soOrderExtendDTO.proServiceSubject" />
                              </td>

                              <!-- 临时状态 -->
                              <th>临时状态</th>
                              <td v-if="formData.soOrderExtendDTO.tempStat == 1">登记</td>
                              <td v-else-if="formData.soOrderExtendDTO.tempStat == 2">发布</td>
                              <td v-else-if="formData.soOrderExtendDTO.tempStat == 5">已派网点</td>
                              <td v-else-if="formData.soOrderExtendDTO.tempStat == 6">网点已接单</td>
                              <td v-else-if="formData.soOrderExtendDTO.tempStat == 9">已派师傅</td>
                              <td v-else-if="formData.soOrderExtendDTO.tempStat == 10">师傅已接单</td>
                              <td v-else-if="formData.soOrderExtendDTO.tempStat == 11">已预约</td>
                              <td v-else-if="formData.soOrderExtendDTO.tempStat == 13">已出发</td>
                              <td v-else-if="formData.soOrderExtendDTO.tempStat == 17">已上门</td>
                              <td v-else-if="formData.soOrderExtendDTO.tempStat == 20">完工暂存</td>
                              <td v-else-if="formData.soOrderExtendDTO.tempStat == 97">申请关闭</td>
                              <td v-else-if="formData.soOrderExtendDTO.tempStat == 98">挂起</td>
                              <td v-else-if="formData.soOrderExtendDTO.tempStat == 99">取消</td>
                              <td v-else></td>

                              <th>超期核实文本</th>
                              <td>{{ formData.soOrderExtendDTO.timeCheckText }}</td>

                              <th>配件更换数量(个)</th>
                              <td>{{ formData.soOrderExtendDTO.partsQty }}</td>
                            </tr>

                            <tr>
                              <th>回访次数</th>
                              <td>{{ formData.soOrderExtendDTO.recallNumber }}</td>

                              <th>回访方式</th>
                              <td v-if="formData.soOrderExtendDTO.recallType == 1">人工回访</td>
                              <td v-else-if="formData.soOrderExtendDTO.recallType == 2">机器人回访</td>
                              <td v-else-if="formData.soOrderExtendDTO.recallType == 3">微信点评</td>
                              <td v-else-if="formData.soOrderExtendDTO.recallType == 4">短信评价</td>
                              <td v-else-if="formData.soOrderExtendDTO.recallType == 5">批量导入</td>
                              <td v-else></td>

                              <th>是否号码重单</th>
                              <td v-if="formData.soOrderExtendDTO.isSamePhone == 0">否</td>
                              <td v-else-if="formData.soOrderExtendDTO.isSamePhone == 1">是</td>
                              <td v-else></td>
                            </tr>

                            <tr>
                              <th>工单跟进记录</th>
                              <td colspan="6">{{ formData.soOrderExtendDTO.traceRecordText }}</td>
                            </tr>
                            <tr>
                              <th>工单催单记录</th>
                              <td colspan="6">{{ formData.soOrderExtendDTO.urgeRecordText }}</td>
                            </tr>
                          </el-tab-pane>
                          <el-tab-pane label="协助人" name="nine"></el-tab-pane>

                          <el-tab-pane label="评论&回访" name="six"
                                       style="max-height: 360px;position: relative;overflow-y: scroll;">

                            <tr>
                              <p class="title_p">用户评价</p>
                            </tr>
                            <template v-if="formData.soOrderCommentDTOList.length > 0">
                              <div style="border: 1px solid rgb(242, 242, 242);margin-bottom: 15px;"
                                   v-for="item in formData.soOrderCommentDTOList" :key="item.id">
                                <tr>
                                  <th>
                                    {{$t('center.EvaluationSource')}}
                                  </th>
                                  <td v-if="item.sources == null"></td>
                                  <td v-else-if="item.sources == 1">电商接口</td>
                                  <td v-else-if="item.sources == 2">短信回复评价</td>
                                  <td v-else-if="item.sources == 3">用户微信评价</td>
                                  <td v-else-if="item.sources == 4">APP扫码评价</td>
                                  <td v-else-if="item.sources == 5">400回访</td>
                                  <td v-else></td>
                                  <th>
                                    {{$t('center.appraiser')}}
                                  </th>
                                  <td>
                                    {{ item.evaluateBy ? item.evaluateBy : '\xa0' }}
                                  </td>
                                  <th>
                                    {{$t('center.EvaluationTime')}}
                                  </th>
                                  <td>
                                    {{ item.evaluateTime }}
                                  </td>
                                  <th style="visibility: hidden">

                                  </th>
                                  <td>

                                  </td>
                                </tr>
                                <tr>
                                  <th>
                                    {{$t('center.OverallEvaluation')}}

                                  </th>

                                  <td v-if="item.topLevel == 1">非常满意</td>
                                  <td v-else-if="item.topLevel == 2">满意</td>
                                  <td v-else-if="item.topLevel == 3">一般</td>
                                  <td v-else-if="item.topLevel == 4">不满意</td>
                                  <td v-else-if="item.topLevel == 5">非常不满意</td>
                                  <td v-else></td>
                                  <td
                                    style="text-align: right;    text-decoration: underline;color: rgb(33, 150, 243);">
                                    <span @click="openRecordDialog2(item)">{{$t('center.MoreInformation')}}</span>
                                  </td>
                                </tr>
                              </div>
                            </template>
                            <div v-else style="border: 1px solid rgb(242, 242, 242);margin-bottom: 15px;">

                              <tr>
                                <th>
                                  {{$t('center.EvaluationSource')}}
                                </th>
                                <td></td>
                                <th>
                                  {{$t('center.appraiser')}}
                                </th>
                                <td>

                                </td>
                                <th>
                                  {{$t('center.EvaluationTime')}}

                                </th>
                                <td>
                                </td>
                                <th style="visibility: hidden">
                                </th>
                                <td>
                                </td>
                              </tr>
                              <tr>
                                <th>
                                  {{$t('center.OverallEvaluation')}}
                                </th>
                                <td></td>
                                <td style="text-align: right;    text-decoration: underline;color: rgb(33, 150, 243);">
                                  <span>{{$t('center.MoreInformation')}}</span>
                                </td>
                              </tr>
                            </div>

                            <tr>
                              <p class="title_p">{{$t('center.ReturnVisitRecord')}}</p>
                            </tr>
                            <template v-if="formData.soRecallHistoryDTOList.length > 0">
                              <div style="border: 1px solid rgb(242, 242, 242);margin-bottom: 15px;"
                                   v-for="item in formData.soRecallHistoryDTOList" :key="item.id">
                                <tr>
                                  <th>
                                    {{$t('center.ReturnTime')}}
                                  </th>
                                  <td>
                                    {{ item.recallDate }}
                                  </td>
                                  <th>
                                    {{$t('center.ReturnVisitStatus')}}
                                  </th>
                                  <td v-if="item.finishRecall == null">
                                  </td>
                                  <td v-else-if="item.finishRecall == 0">未回访</td>
                                  <td v-else-if="item.finishRecall == 1">回访失败</td>
                                  <td v-else-if="item.finishRecall == 5">回访成功</td>
                                  <td v-else></td>
                                  <th>
                                    {{$t('center.ReturnVisitor')}}
                                  </th>
                                  <td>
                                    {{ item.recallMan }}
                                  </td>
                                  <th>
                                    {{$t('center.ReturnVisit')}}
                                  </th>
                                  <td v-if="item.huiFangQingKuang == null">
                                  </td>
                                  <td v-else-if="item.huiFangQingKuang == 1">属实</td>
                                  <td v-else-if="item.huiFangQingKuang == 2">不属实</td>
                                  <td v-else-if="item.huiFangQingKuang == 3">不确定</td>
                                  <td v-else></td>
                                </tr>
                                <tr>
                                  <th>
                                    {{$t('center.satisfaction')}}
                                  </th>
                                  <td v-if="item.manYi == null">
                                  </td>
                                  <td v-else-if="item.manYi == 1">非常满意</td>
                                  <td v-else-if="item.manYi == 2">满意</td>
                                  <td v-else-if="item.manYi == 3">一般</td>
                                  <td v-else-if="item.manYi == 4">不满意</td>
                                  <td v-else-if="item.manYi == 5">非常不满意</td>
                                  <td v-else></td>
                                  <td
                                    style="text-align: right;    text-decoration: underline;color: rgb(33, 150, 243);">
                                    <span @click="showDetails(formData.orderNo, item)">{{$t('center.MoreInformation')}}</span>
                                  </td>
                                </tr>
                              </div>
                            </template>
                            <div v-else style="border: 1px solid rgb(242, 242, 242);margin-bottom: 15px;">
                              <tr>
                                <th>
                                  {{$t('center.ReturnTime')}}
                                </th>
                                <td>

                                </td>
                                <th>
                                  {{$t('center.ReturnVisitStatus')}}
                                </th>
                                <td>
                                </td>

                                <th>
                                  {{$t('center.ReturnVisitor')}}
                                </th>
                                <td>

                                </td>
                                <th>
                                  {{$t('center.ReturnVisit')}}
                                </th>
                                <td>
                                </td>
                              </tr>
                              <tr>
                                <th>
                                  {{$t('center.satisfaction')}}
                                </th>
                                <td>
                                </td>
                                <td style="text-align: right;    text-decoration: underline;color: rgb(33, 150, 243);">
                                  <span>{{$t('center.MoreInformation')}}</span>
                                </td>
                              </tr>
                            </div>

                          </el-tab-pane>
                          <el-tab-pane label="预审记录" name="seven">
                            <div class="product" style="">
                              <vxe-table ref="filterTable" height="200"
                                         :data="formData.soOrderPreconditionResultDTOList" class="table_item pic_item"
                                         style="margin:12px auto;width: 95%;" :stripe="true"
                                         :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                                         :row-config="{ height: 30, isHover: true, padding: 0, }"
                                         :row-style="{ fontSize: '12px', }" show-overflow :column-config="{ resizable: true }">
                                <!--                    <vxe-column type="seq" width="55" title="序号"/>-->
                                <vxe-column field="preconditionName" title="预审条件" width="" />
                                <vxe-column field="isPast" title="是否通过" width="">
                                  <template #default="{ row }">
                                    <span v-if="row.isPast == 1">是</span>
                                    <span v-else>否</span>
                                  </template>
                                </vxe-column>
                                <vxe-column field="afterFlow" title="流向" width="">
                                  <template #default="{ row }">
                                    <span v-if="row.afterFlow == 1">必访</span>
                                    <span v-else-if="row.afterFlow == 2">申诉</span>
                                    <span v-else-if="row.afterFlow == 3">挂起</span>
                                    <span v-else-if="row.afterFlow == 4">重新完工</span>
                                    <span v-else-if="row.afterFlow == 9">关闭</span>
                                    <span v-else></span>
                                  </template>
                                </vxe-column>
                                <!-- <vxe-column field="remark" title="备注" width=""/> -->

                              </vxe-table>

                            </div>
                          </el-tab-pane>
                          <el-tab-pane label="接口信息" name="eight">
                            <tr>
                              <th>
                                外部系统传单标识
                              </th>
                              <td v-if="formData.soOrderExtendDTO.sendFlag == null"></td>
                              <td v-if="formData.soOrderExtendDTO.sendFlag == 0">未传</td>
                              <td v-if="formData.soOrderExtendDTO.sendFlag == 1">失败</td>
                              <td v-if="formData.soOrderExtendDTO.sendFlag == 2">已传</td>

                              <th>
                                外部系统传单返回信息
                              </th>
                              <td>
                                {{ formData.soOrderExtendDTO.sendMessage }}
                              </td>
                              <th>
                                外部系统传单时间
                              </th>
                              <td>
                                {{ formData.soOrderExtendDTO.sendDate }}
                              </td>

                              <th>
                                传第三方网点接口状态
                              </th>
                              <td v-if="formData.soOrderExtendDTO.thirdSendFlag == null"></td>
                              <td v-if="formData.soOrderExtendDTO.thirdSendFlag == 0">未传</td>
                              <td v-if="formData.soOrderExtendDTO.thirdSendFlag == 1">失败</td>
                              <td v-if="formData.soOrderExtendDTO.thirdSendFlag == 2">已传</td>

                            </tr>
                            <tr>
                              <th>
                                传第三方网点接口时间
                              </th>
                              <td>
                                {{ formData.soOrderExtendDTO.thirdSendDate }}
                              </td>

                              <th>
                                传第三方网点接口备注
                              </th>
                              <td>
                                {{ formData.soOrderExtendDTO.thirdSendMessage }}
                              </td>

                              <th>
                                天猫服务市场的工单ID
                              </th>
                              <td>
                                {{ formData.soOrderExtendDTO.tmfworderid }}
                              </td>

                              <th>
                                天猫服务市场的用户ID
                              </th>
                              <td>
                                {{ formData.soOrderExtendDTO.tbcustomerid }}
                              </td>
                            </tr>
                            <tr>
                              <th>是否电商好评</th>
                              <td v-if="formData.soOrderExtendDTO.commercePraise == null"></td>
                              <td v-if="formData.soOrderExtendDTO.commercePraise == 1">是</td>
                              <td v-if="formData.soOrderExtendDTO.commercePraise == 0">否</td>
                            </tr>
                          </el-tab-pane>
                        </el-tabs>
                      </template>


                      </tbody>
                    </table>
                  </div>
                  <div style="height:160px"></div>
                </div>
                <div style="width: 20%;" class="bread">
                  <div style="padding-bottom: 90px;    margin-top: 10px; margin-left: 5px;">
                    <div class="title_icon"><i class="el-icon-date"></i></div>
                    <span>工单履历</span>
                    <el-timeline class="card_bread" style="position:relative">

                      <el-timeline-item v-for="item in formData.soOrderOperationDTOList" placement="top">
                        <div class="title_time"><span class="span1">{{ item.title }} </span>
                          <span class="span2">{{ item.createTime }}</span>
                        </div>
                        <div style="font-size: 13px;margin-top: 7px;"><span style="color: #2a6494 !important;">操作人:{{
                            item.createBy }} </span></div>
                        <el-card class="card">
                          <p>{{ item.content }}</p>
                        </el-card>
                      </el-timeline-item>


                      <!--                  <el-timeline-item-->
                      <!--                    v-for="item in tenant.soOrderOperationDTOList.slice(3, tenant.soOrderOperationDTOList.length)"-->
                      <!--                    :timestamp="item.createTime" placement="top">-->
                      <!--                    <el-card class="card">-->
                      <!--                      <div>{{ item.title }}</div>-->
                      <!--                      <p>{{ item.content }}</p>-->
                      <!--                    </el-card>-->
                      <!--                  </el-timeline-item>-->


                    </el-timeline>

                  </div>
                </div>
              </dix>
            </el-tab-pane>
            <el-tab-pane label="服务报告" name="second">
              <div class="d-cont edit-mce-box"
                   style=" overflow: unset!important;overflow-y: scroll!important;height: 100vh!important; ">
                <div class="d-item">
                  <div class="title first"><b>服务内容</b></div>
                  <table class="table-detail" style="display: block;">
                    <tbody style="display: block;">

                    <tr style="display: block;">
                      <!-- <th>故障现象</th>
                            <td>{{ formData.sysmtomName }}</td>

                            <th>故障原因</th>
                            <td>{{ formData.reasonName }}</td> -->

                      <th>完工状态</th>
                      <td v-if="formData.soOrderProcessDTO.finishStatus == 1"><span class="btn_f">正常完工</span></td>
                      <td v-else-if="formData.soOrderProcessDTO.finishStatus == 2"><span class="btn_t">无法完工</span></td>
                      <td v-else-if="formData.soOrderProcessDTO.finishStatus == 3"><span class="btn_t">需重新完工</span></td>
                      <td v-else></td>
                      <th>申请保外转保内</th>
                      <td v-if="formData.outTransIn == 0"><span class="btn_f">否</span></td>
                      <td v-else-if="formData.outTransIn == 1"><span class="btn_t">是</span></td>
                      <td v-else></td>
                      <th>维修状态</th>
                      <td v-if="formData.soOrderProcessDTO.fixStatus == 1"><span class="btn_f">正常维修</span></td>
                      <td v-else-if="formData.soOrderProcessDTO.fixStatus == 2"><span class="btn_t">退机</span></td>
                      <td v-else-if="formData.soOrderProcessDTO.fixStatus == 3"><span class="btn_t">退换机</span></td>
                      <td v-else></td>
                    </tr>
                    <tr style="display: block;">
                      <th>
                        完工备注
                      </th>
                      <td colspan="7">
                        {{ formData.soOrderProcessDTO.finishNote }}
                      </td>
                    </tr>
                    <div class="product" style="">
                      <vxe-table ref="filterTable" :data="formData.soOrderFaultDTOList" class="table_item"
                                 style="margin: 1px auto; width: 94%;" :stripe="true"
                                 :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', fontWeight: '600', color: '#808080', width: '95%' }"
                                 :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                                 show-overflow height="100" :column-config="{ resizable: true }">
                        <vxe-column type="seq" width="55">
                        </vxe-column>

                        <vxe-column field="symptomName" title="故障现象"></vxe-column>
                        <vxe-column field="reasonName" title="故障原因" />
                        <vxe-column field="methodName" title="服务措施" />
                        <vxe-column field="serverTypeName" title="服务类型" />
                        <vxe-column field="fee" title="费用" />
                        <!-- <vxe-column field="sitePrice" title="服务费单价" />
                      <vxe-column field="siteFee" title="服务费"  /> -->

                      </vxe-table>
                    </div>
                    </tbody>
                  </table>
                </div>
                <div class="d-item">
                  <div class="title first"><b>配件更换</b>
                    <!-- <el-button type="primary" class="button-sty btn_zdy" @click="AddListRow1_2()">
                      <i class="el-icon-plus"></i>
                      新增
                    </el-button> -->
                  </div>
                  <div>
                    <div>
                      <vxe-table ref="filterTable" :data="formData.soOrderPartsDTOList" class="table_item"
                                 style="margin: 1px auto; width: 94%;" :stripe="true"
                                 :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                                 :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                                 show-overflow height="100" :column-config="{ resizable: true }">
                        <vxe-column type="selection" width="55">
                        </vxe-column>
                        <vxe-column field="partsName" title="新配件名称" />
                        <vxe-column field="oldPartsName" title="旧配件名称" />
                        <vxe-column field="barcode" title="配件条码" />
                        <vxe-column field="sitePrice" title="网点价" />
                        <vxe-column field="qty" title="更换数量" />
                        <vxe-column field="amount" title="金额" />
                        <vxe-column field="returnQty" title="网点返厂数量" />
                        <vxe-column field="returnRevQty" title="返厂数量" />
                        <!--                        <vxe-column field="isNeedReturn" title="是否需要返厂" width="110" :formatter="formatter"/>-->
                        <vxe-column field="isNeedReturn" title="是否需要返厂" width="">
                          <template #default="{ row }">
                            <span v-if="row.isNeedReturn == 1">是</span>
                            <span v-if="row.isNeedReturn == 0">否</span>
                          </template>
                        </vxe-column>
                        <vxe-column field="isCheck" title="是否需要审核" width="">
                          <template #default="{ row }">
                            <span v-if="row.isCheck == 1">是</span>
                            <span v-if="row.isCheck == 0">否</span>
                          </template>
                        </vxe-column>
                        <!-- 冲账 -->
                        <vxe-column field="offAccounting" title="是否冲帐" :formatter="formatter4" />
                        <vxe-column field="offAccountingNo" title="冲帐单号" />
                      </vxe-table>
                    </div>
                  </div>
                </div>
                <div class="d-item">
                  <div class="title first"><b>费用结算(服务商)</b> <span class="expense">本单费用:{{
                      formData.soOrderSettleDTO.siteFinalAmount }}</span></div>

                  <table class="table-detail">
                    <tbody>
                    <div>
                      <tr>
                        <th>标准基数</th>
                        <td>{{ formData.soOrderSettleDTO.standardBase }}</td>
                        <th>服务费用</th>
                        <td>
                          {{ formData.soOrderSettleDTO.siteAmount }}
                          <el-checkbox v-model="formData.soOrderSettleDTO.siteAmountPass"></el-checkbox>
                          (是否通过)
                        </td>
                      </tr>
                    </div>
                    <div>
                      <tr>
                        <th>
                          区域系数
                        </th>
                        <td>
                          {{ formData.soOrderSettleDTO.areaCoefficient }}
                        </td>

                        <th>
                          网点星级系数
                        </th>
                        <td>
                          {{ formData.soOrderSettleDTO.startCoefficient }}
                        </td>

                        <th>满意系数</th>
                        <td>
                          {{ formData.soOrderSettleDTO.satisfactionCoefficient }}
                        </td>
                      </tr>
                    </div>
                    <div>
                      <tr>
                        <th>
                          红利
                        </th>
                        <td>
                          {{ formData.soOrderSettleDTO.bonusFee }}
                          <el-checkbox v-model="formData.soOrderSettleDTO.bonusFeePass"></el-checkbox>

                        </td>

                        <th>
                          奖罚
                        </th>
                        <td>
                          {{ formData.soOrderSettleDTO.rewardAmount }}<span class="Instructions">查看原因</span>
                        </td>

                        <th>远程费用</th>
                        <td>
                          {{ formData.soOrderSettleDTO.longDistanceAmount }}<span class="Instructions">远程公里</span>
                        </td>

                        <th>
                          特设费用
                        </th>
                        <td>
                          {{ formData.soOrderSettleDTO.specailAmount }}<span class="Instructions"
                                                                             @click="openRecordDialog(e)">查看凭证</span>
                          <!-- <i class="el-icon-tickets" style="margin-left:10px;color: #2a6494;"
                          @click="show3 = !show3">详细</i> -->
                        </td>

                      </tr>
                    </div>


                    <div v-for="item in dataList">
                      <tr>
                        <th v-if="item.length > 0">{{ item[0].key }}</th>
                        <td v-if="item.length > 0">{{ item[0].value }}</td>

                        <th v-if="item.length > 1">{{ item[1].key }}</th>
                        <td v-if="item.length > 1">{{ item[1].value }}</td>

                        <th v-if="item.length > 2">{{ item[2].key }}</th>
                        <td v-if="item.length > 2">{{ item[2].value }}</td>

                        <th v-if="item.length > 3">{{ item[3].key }}</th>
                        <td v-if="item.length > 3">{{ item[3].value }}</td>
                      </tr>
                    </div>

                    <!--                      <td>-->
                    <!--                        <el-input type="text" autocomplete="off" v-model="tenant.esiteOrderMan4" clearable/>-->
                    <!--                      </td>-->

                    </tbody>
                  </table>
                  <div>

                    <!--                    <vxe-table ref="filterTable" :data="formData.soOrderFeeAttribute"-->
                    <!--                      style="margin: 1px auto; width: 94%;" :stripe="true"-->
                    <!--                      :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"-->
                    <!--                      :row-config="{height: 30,isHover: true,padding: 0,}" :row-style="{ fontSize: '12px',  }"-->
                    <!--                      show-overflow height="100" :column-config="{ resizable: true }">-->

                    <!--                      <vxe-column type="seq" width="55"> </vxe-column>-->
                    <!--                      <vxe-column field="feeAttributeId" title="费用类型" width="150" />-->
                    <!--                      <vxe-column field="feeAttributeName" title="费用名称" width="150" />-->
                    <!--                      <vxe-column field="amount" title="金额" width="100" />-->


                    <!--                    </vxe-table>-->
                    <vxe-table ref="filterTable" :data="soOrderSpecailFeeListToCompany"
                               style="margin: 1px auto; width: 94%;margin-top: 10px;" :stripe="true"
                               :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                               :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                               show-overflow height="100" :column-config="{ resizable: true }">
                      <vxe-column type="seq" width="55">
                      </vxe-column>

                      <!-- <vxe-column field="itemCode" title="产品编码"/> -->
                      <!--                      <vxe-column field="feeType" title="类型"/>-->

                      <vxe-column field="subjectName" title="特设费用名称" />
                      <vxe-column field="qty" title="数量" />
                      <vxe-column field="price" title="单价" />
                      <vxe-column field="amount" title="金额" />
                      <vxe-column field="unit" title="计价单位" />


                    </vxe-table>

                  </div>
                </div>
                <div class="d-item">
                  <div class="title first">
                    <b>费用结算(用户)</b>
                    <span class="expense">本单合计费用:{{ formData.soOrderSettleDTO.siteFinalAmount }}</span>
                    <!-- <span @click="more = !more" class="more">查看更多</span> -->

                  </div>
                  <!-- <div v-show="more"> -->
                  <el-collapse>
                    <el-collapse-item name="1">
                      <table class="table-detail">
                        <tbody>
                        <tr>

                          <th>优惠金额</th>
                          <td>
                            {{ formData.soOrderSettleDTO.userPayDiscount }}
                          </td>
                          <th>支付方式</th>
                          <td>
                            {{ formData.soOrderSettleDTO.userPayType }}
                          </td>

                          <th>付款方名称</th>
                          <td>
                            {{ formData.soOrderSettleDTO.userPayName }}
                          </td>

                          <th>付款方帐号</th>
                          <td>
                            {{ formData.soOrderSettleDTO.userPayAccount }}
                          </td>


                          <th>支付流水</th>
                          <td>
                            {{ formData.soOrderSettleDTO.userPayNo }}
                          </td>

                        </tr>
                        <tr>
                          <th>支付状态</th>
                          <td v-if="formData.soOrderSettleDTO == null || formData.soOrderSettleDTO.userPayStat == null">
                          </td>
                          <td v-else-if="formData.soOrderSettleDTO.userPayStat == 1">未支付</td>
                          <td v-else-if="formData.soOrderSettleDTO.userPayStat == 2">待支付</td>
                          <td v-else-if="formData.soOrderSettleDTO.userPayStat == 5">支付成功</td>
                          <td v-else-if="formData.soOrderSettleDTO.userPayStat == 8">支付失败</td>
                          <td v-else-if="formData.soOrderSettleDTO.userPayStat == 9">支付关闭</td>
                          <td v-else></td>
                          <th>支付时间</th>
                          <td>
                            {{ formData.soOrderSettleDTO.userPayTime }}
                          </td>

                          <th>支付备注</th>
                          <td>
                            {{ formData.soOrderSettleDTO.userPayStatMsg }}
                          </td>
                          <th>用户付费理由</th>
                          <td>
                            {{ formData.soOrderSettleDTO.userPayRemark }}
                          </td>
                        </tr>
                        <tr>
                          <th>付费凭证1</th>
                          <td>
                            <el-image v-if="formData.soOrderResultDTO.userPayPic1"
                                      :src="formData.soOrderResultDTO.userPayPic1" fit="fit" :preview-src-list="srcList"
                                      :initial-index="0"></el-image>
                            <el-image v-else>
                              <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"
                                   style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                              </div>
                            </el-image>
                          </td>
                          <th>付费凭证2</th>
                          <td>
                            <el-image v-if="formData.soOrderResultDTO.userPayPic2"
                                      :src="formData.soOrderResultDTO.userPayPic2" fit="fit" :preview-src-list="srcList"
                                      :initial-index="0"></el-image>
                            <el-image v-else>
                              <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"
                                   style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                              </div>
                            </el-image>
                          </td>
                          <th>付费凭证3</th>
                          <td>
                            <el-image v-if="formData.soOrderResultDTO.userPayPic3"
                                      :src="formData.soOrderResultDTO.userPayPic3" fit="fit" :preview-src-list="srcList"
                                      :initial-index="0"></el-image>
                            <el-image v-else>
                              <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"
                                   style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                              </div>
                            </el-image>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                      <div>
                        <vxe-table ref="filterTable" :data="soOrderSpecailFeeListToUser"
                                   style="margin: 1px auto; width: 94%;margin-top: 10px;" :stripe="true"
                                   :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                                   :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                                   show-overflow height="100" :column-config="{ resizable: true }">
                          <vxe-column type="seq" width="55">
                          </vxe-column>

                          <!-- <vxe-column field="itemCode" title="产品编码"/> -->
                          <!--                      <vxe-column field="siteFee" title="类型" width=""/>-->

                          <vxe-column field="subjectName" title="特设费用名称" />
                          <vxe-column field="qty" title="数量" />
                          <vxe-column field="price" title="单价" />
                          <vxe-column field="amount" title="金额" />
                          <vxe-column field="unit" title="计价单位" />


                        </vxe-table>
                      </div>
                    </el-collapse-item></el-collapse>
                  <!-- </div> -->
                </div>
                <div class="d-item">
                  <div class="title first"><b>完工资料</b></div>
                  <table class="table-detail">
                    <tbody>
                    <tbody>
                    <div>
                      <tr>
                        <div>
                          <th>机器条码1</th>
                          <td>
                            {{ formData.soOrderResultDTO.inCode }}
                          </td>

                          <th>机器条码2</th>
                          <td>
                            {{ formData.soOrderResultDTO.outCode }}
                          </td>

                          <th>生产日期</th>
                          <td>
                            {{ formData.soOrderResultDTO.productDate }}
                          </td>

                          <th>
                            安装时间
                          </th>
                          <td>
                            {{ formData.soOrderResultDTO.installDate }}
                          </td>
                        </div>
                      </tr>
                    </div>


                    <tr>
                      <div style="" class="pic_main">
                        <div class="pic_item">
                          <span>图片1：</span>
                          <el-image v-if="formData.soOrderResultDTO.finishPic1"
                                    :src="formData.soOrderResultDTO.finishPic1" fit="fit" :preview-src-list="srcList"
                                    :initial-index="0"></el-image>
                          <el-image v-else>
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"
                                 style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                            </div>
                          </el-image>
                        </div>

                        <div class="pic_item">
                          <span>图片2:</span>
                          <el-image v-if="formData.soOrderResultDTO.finishPic2"
                                    :src="formData.soOrderResultDTO.finishPic2" fit="fit" :preview-src-list="srcList"
                                    :initial-index="1"></el-image>
                          <el-image v-else>
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"
                                 style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                            </div>
                          </el-image>
                        </div>
                        <div class="pic_item">
                          <span>图片3:</span>
                          <el-image v-if="formData.soOrderResultDTO.finishPic3"
                                    :src="formData.soOrderResultDTO.finishPic3" fit="fit" :preview-src-list="srcList"
                                    :initial-index="2"></el-image>
                          <el-image v-else>
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"
                                 style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                            </div>
                          </el-image>
                        </div>
                        <div class="pic_item">
                          <span>图片4:</span>
                          <el-image v-if="formData.soOrderResultDTO.finishPic4"
                                    :src="formData.soOrderResultDTO.finishPic4" fit="fit" :preview-src-list="srcList"
                                    :initial-index="3"></el-image>
                          <el-image v-else>
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"
                                 style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                            </div>
                          </el-image>
                        </div>
                        <div class="pic_item">
                          <span>图片5:</span>
                          <el-image v-if="formData.soOrderResultDTO.finishPic5"
                                    :src="formData.soOrderResultDTO.finishPic5" fit="fit" :preview-src-list="srcList"
                                    :initial-index="4"></el-image>
                          <el-image v-else>
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"
                                 style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                            </div>
                          </el-image>
                        </div>
                        <div class="pic_item">
                          <span>图片6:</span>
                          <el-image v-if="formData.soOrderResultDTO.finishPic6"
                                    :src="formData.soOrderResultDTO.finishPic6" fit="fit" :preview-src-list="srcList"
                                    :initial-index="5"></el-image>
                          <el-image v-else>
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"
                                 style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                            </div>
                          </el-image>
                        </div>
                        <div class="pic_item">
                          <span>图片7:</span>
                          <el-image v-if="formData.soOrderResultDTO.finishPic7"
                                    :src="formData.soOrderResultDTO.finishPic7" fit="fit" :preview-src-list="srcList"
                                    :initial-index="6"></el-image>
                          <el-image v-else>
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"
                                 style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                            </div>
                          </el-image>
                        </div>
                      </div>
                    </tr>
                    <div>

                    </div>
                    </tbody>
                    </tbody>
                  </table>

                </div>
                <div style="height:160px"></div>
              </div>
            </el-tab-pane>

            <el-tab-pane label="工单申诉" name="third">
              <div class="d-cont edit-mce-box"
                   style=" overflow: unset!important;overflow-y: scroll!important;height: 100vh!important; ">
                <div class="d-item">
                  <div class="first">
                  </div>
                  <div class="card_item">
                    <el-steps :active="2" simple>
                      <el-step title="发起申诉" icon="el-icon-edit"></el-step>
                      <el-step title="服务商申诉" icon="el-icon-edit-outline"></el-step>
                      <el-step title="服务中心审核" icon="el-icon-document"></el-step>
                      <el-step title="总部审核" icon="el-icon-document-checked"></el-step>
                    </el-steps>
                  </div>
                </div>

                <div class="d-item">
                  <div class="first">
                    <div class="undergo">
                      <el-timeline>
                        <el-timeline-item placement="top" v-for="(item, index) in formData.soOrderComplainDTOList"
                                          style="position: relative;">
                          <el-card>
                            <div class="audit" style="margin-left: 10px;padding-top: 5px;"><span>{{
                                item.createTime
                              }} </span>
                              <span style="margin: 0px 20px">岗位：{{ item.poster }}</span> <span>创建人：{{
                                  item.createBy
                                }}</span>
                            </div>
                            <!-- <h4>更新 Github 模板</h4> -->
                            <p style="margin-left: 10px;">{{
                                item.content
                              }}</p>
                            <div class="audit" style="display: flex; margin-left: 10px;margin-bottom: 5px;">
                              <span style="line-height: 63px;">图片： </span>
                              <div>
                                <el-image v-if="item.fileUrl1" :preview-src-list="srcList" fit="fit" :src="item.fileUrl1"
                                          :initial-index="0"></el-image>
                                <el-image v-else>
                                  <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"
                                       style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                                  </div>
                                </el-image>
                              </div>
                            </div>
                          </el-card>
                        </el-timeline-item>
                      </el-timeline>
                    </div>
                  </div>
                </div>
                <div style="height:160px"></div>


              </div>
            </el-tab-pane>


            <!-- <el-tab-pane label="考核单" name="four">
              <div class="d-cont edit-mce-box"
                   style=" overflow: unset!important;overflow-y: scroll!important;height: 100vh!important; ">

                <div class="d-item">
                  <div>
                    <div>
                      <vxe-table ref="filterTable" :data="formData.sfCheckBillDTOList" class="table_item"
                                 style="margin: 1px auto; width: 94%;" :stripe="true"
                                 :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                                 :row-config="{height: 30,isHover: true,padding: 0,}"
                                 :row-style="{ fontSize: '12px',  }"
                                 show-overflow height="100" :column-config="{ resizable: true }">
                        <vxe-column field="billNo" title="考核单号" width="180"/>
                        <vxe-column field="siteName" title="网点名称"/>
                        <vxe-column field="stat" title="状态"/>
                        <vxe-column field="orgName" title="服务中心"/>
                        <vxe-column field="siteName" title="服务商名称"/>
                        <vxe-column field="amount" title="考核类别"/>
                        <vxe-column field="standardAmount" title="考核金额" width="70"/>
                        <vxe-column field="adjustAmount" title="调整金额" width="70"/>
                        <vxe-column field="amount" title="合计金额" width="70"/>
                        <vxe-column field="checkAmount" title="审批金额" width="70"/>
                        <vxe-column field="createBy" title="创建人"/>
                        <vxe-column field="createTime" title="创建时间" width="180"/>
                      </vxe-table>
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane> -->


            <el-tab-pane label="SLA记录" name="five">
              <div class="d-cont edit-mce-box"
                   style=" overflow: unset!important;overflow-y: scroll!important;height: 100vh!important; ">

                <div class="d-item">
                  <div>
                    <div>
                      <vxe-table ref="filterTable" :data="formData.soOrderSlaList" class="table_item"
                                 style="margin: 1px auto; width: 94%;" :stripe="true"
                                 :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                                 :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                                 show-overflow height="100" :column-config="{ resizable: true }">
                        <!--                        <vxe-column type="selection" width="55">-->
                        <!--                        </vxe-column>-->
                        <vxe-column field="slaName" title="SLA名称" width="180" />
                        <vxe-column field="beginDate" title="开始时间" />
                        <vxe-column field="endDate" title="应结束时间" />
                        <vxe-column field="realEndDate" title="实际结束时间" />
                        <vxe-column field="overHours" title="超过小时数" />
                        <vxe-column field="createBy" title="创建人" />
                        <vxe-column field="createTime" title="创建时间" width="180" />
                      </vxe-table>
                    </div>
                  </div>
                </div>

                <div style="height:160px"></div>


              </div>
            </el-tab-pane>


          </el-tabs>
        </div>


      </el-form>
      <!-- 服务区域弹窗表 -->
    </div>
    <el-drawer title="发起申诉" :before-close="handleClose" :visible.sync="initiateAppeal" direction="rtl"
               custom-class="demo-drawer" ref="drawer">
      <div class="demo-drawer__content">
        <el-form :model="form2">
          <el-form-item label="申诉原因" :label-width="formLabelWidth">
            <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 8 }" v-model="form2.appealRemark"
                      autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="申诉凭证" :label-width="formLabelWidth">
            <el-upload class="upload-demo" :action="api.uploadFileUrl"
                       :on-success="(res, file, fileList) => { handleSuccessAppeal(res, file, fileList) }"
                       :on-preview="handlePreviewAppeal" :on-remove="handleRemoveAppeal" :file-list="fileList" :limit="3"
                       :headers="headers" list-type="picture">
              <td align="left">
                <el-button size="small" type="primary">点击上传</el-button>
              </td>
            </el-upload>
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="toInitiateAppeal('site')" :loading="loading">
            {{ loading ? '提交中 ...' : '确 定' }}
          </el-button>
        </div>
      </div>
    </el-drawer>

    <el-drawer title="中心申诉审核" :before-close="handleClose" :visible.sync="initiateAppealOrg" direction="rtl"
               custom-class="demo-drawer" ref="drawer">
      <div class="demo-drawer__content">
        <el-form :model="form2">
          <el-form-item label="审核结果" :label-width="formLabelWidth" style="margin-bottom: 21px;">
            <el-radio-group v-model="radio" @change="radioHandleChange" style="margin-left: 0px;
    margin-bottom: -10px;">
              <el-radio :label="1">同意</el-radio>
              <el-radio :label="2">驳回</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="审核备注" :label-width="formLabelWidth" style="margin-bottom: 21px;">
            <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 8 }" v-model="form2.appealRemark"
                      autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="审核凭证" :label-width="formLabelWidth" style="margin-bottom: 21px;">
            <el-upload class="upload-demo" :action="api.uploadFileUrl"
                       :on-success="(res, file, fileList) => { handleSuccessAppeal(res, file, fileList) }"
                       :on-preview="handlePreviewAppeal" :on-remove="handleRemoveAppeal" :file-list="fileList" :limit="3"
                       :headers="headers" list-type="picture">
              <td align="left">
                <el-button size="small" type="primary">点击上传</el-button>
              </td>
            </el-upload>
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="toInitiateAppeal('org')" :loading="loading">
            {{ loading ? '提交中 ...' : '确 定' }}
          </el-button>
        </div>
      </div>
    </el-drawer>

    <el-drawer title="总部申诉审核" :before-close="handleClose" :visible.sync="initiateAppealCompany" direction="rtl"
               custom-class="demo-drawer" ref="drawer">
      <div class="demo-drawer__content">
        <el-form :model="form2">
          <el-form-item label="审核结果" :label-width="formLabelWidth" style="margin-bottom: 21px;">
            <el-radio-group v-model="radio" @change="radioHandleChange" style="margin-left: 0px;
    margin-bottom: -10px;">
              <el-radio :label="1">同意</el-radio>
              <el-radio :label="2">驳回</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="审核备注" :label-width="formLabelWidth" style="margin-bottom: 21px;">
            <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 8 }" v-model="form2.appealRemark"
                      autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="审核凭证" :label-width="formLabelWidth" style="margin-bottom: 21px;">
            <el-upload class="upload-demo" :action="api.uploadFileUrl"
                       :on-success="(res, file, fileList) => { handleSuccessAppeal(res, file, fileList) }"
                       :on-preview="handlePreviewAppeal" :on-remove="handleRemoveAppeal" :file-list="fileList" :limit="3"
                       :headers="headers" list-type="picture">
              <td align="left">
                <el-button size="small" type="primary">点击上传</el-button>
              </td>
            </el-upload>
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="toInitiateAppeal('company')" :loading="loading">
            {{ loading ? '提交中 ...' : '确 定' }}
          </el-button>
        </div>
      </div>
    </el-drawer>
    <!-- 核销记录 -->
    <expenseDialog v-if="recordDialog" :areaObj3="areaObj3" :visiable.sync="recordDialog" multi="true" />

    <!--工单操作-->
    <zhiPaiDialog v-if="showAssignDialog" :visiable.sync="showAssignDialog" multi="true" :orderId="dataId"
                  :assginType="assginType" @commitSiteRow="commitSiteRow" />
    <mapDialog v-if="showAssignByMapDialog" :visiable.sync="showAssignByMapDialog" multi="true" :param="assignSiteParam"
               :orderId="dataId" :assginType="assginType" @commitSiteRow="commitSiteRow" />
    <assignDialog v-if="showOrgDialog" @commitOrgSelect="commitOrgSelect" :visiable.sync="showOrgDialog" multi="true"
                  :orderId="dataId" />
    <closeOrderDialog v-if="showCloseOrderDialog" @closeOrderRemark="closeOrderRemark"
                      :visiable.sync="showCloseOrderDialog" multi="true" :orderId="dataId" />
    <OrderFinishOrRejectDialog v-if="showOrderFinishOrRejectDialog" @closeDialog="closeDialog"
                               :visiable.sync="showOrderFinishOrRejectDialog" multi="true" :orderId="dataId" :type="isFinishOrReject" />
    <orderRemark v-if="showOrderRemaekDialog" @followUpOrderRemark="followUpOrderRemark"
                 :visiable.sync="showOrderRemaekDialog" :param="orderRemarkParam" />
    <itemDialog v-if="showItemDialog" @commitSelectedRow="commitItemRow" :visiable.sync="showItemDialog" :multi="true" />
    <cancelCheckDialog v-if="showCancelCheckDialog" @doCancelCheck="doCancelCheck" :visiable.sync="showCancelCheckDialog"
                       :param="orderRemarkParam"></cancelCheckDialog>
    <!-- 服务商端操作 -->
    <!-- 派工程师 -->
    <dispatchEngineer v-if="dispatchEngineerDialog" @closeDispatchEngineer="closeDispatchEngineer"
                      :visiable.sync="dispatchEngineerDialog" :param="orderRemarkParam" />
    <!-- 派下级商-->
    <subcontractor v-if="subcontractorDialog" @closeSubcontractor="closeSubcontractor"
                   :visiable.sync="subcontractorDialog" :param="orderRemarkParam" />
    <book v-if="bookDialog" @closeBook="closeBook" :visiable.sync="bookDialog" :param="orderRemarkParam" />
    <!-- 完工确定 -->
    <completion v-if="completionDialog" @closeCompletionDialog="closeCompletionDialog" :visiable.sync="completionDialog"
                :param="orderRemarkParam" />
    <!-- 完工确定 -->
    <completionComfirm v-if="completComfirmDialog" @closeCompletComfirmDialog="closeCompletComfirmDialog"
                       :visiable.sync="completComfirmDialog" :param="orderRemarkParam" />
    <!-- 修改工单 -->
    <orderEditDialog v-if="showOrderEditDialog" @closeEdit="closeEdit" editFrom="view" :orderId="formData.id"
                     :visiable.sync="showOrderEditDialog" multi="true" />
    <!-- 用户评价 -->
    <recordDialog v-if="recordDialog2" :evaluate="evaluate" :visiable.sync="recordDialog2" multi="true" />

    <!--工单详情弹窗-->
    <order-detail-dialog :row1="associateDocumentId"
                         v-if="showOrderDetailDialog"
                         :visiable.sync="showOrderDetailDialog"
                         @closeD="() => {showOrderDetailDialog = false}"
    />

    <!--责任判断-->
    <order-judging-dialog v-if="showOrderJudgingDialog"
                          :visiable.sync="showOrderJudgingDialog"
                          :row-data="formData"
                          @goBackIndex="goBackIndex"
    />

    <!--投诉处理-->
    <order-complaint-handling-dialog v-if="showOrderComplaintHandlingDialog"
                                     :visiable.sync="showOrderComplaintHandlingDialog"
                                     :row-data="formData"
                                     @goBackIndex="goBackIndex"
    />

    <!-- 回访记录弹窗 -->
    <showDetailsDialog v-if="showDetailsDialog" @closeD="closeD2" :row1="row2" :workNumber="workNumber"
                       :visiable.sync="showDetailsDialog" multi="true" />
    <!-- 关联工单共用弹出层 -->
    <commonDetails v-if="showCommonDetails" @closeD="closeD" :row11="row11" :visiable.sync="showCommonDetails"
                   :typeName="typeName" :processId="processId" />
  </div>
</template>

<script>
import Tinymce from '@/components/Tinymce';
import request from "@/router/axios";
// import preconditionDialog from './dialog';
// import areaDialog from './areadialog.vue';
import store from "@/store";
// 特设费用凭证
import expenseDialog from "@/views/workorder/business/common/expenseDialog.vue";
// 城市三级联动
import {regionData} from "element-china-area-data";
import api from "@/api/projectApi";

import assignDialog from "@/views/dialogCommon/orgDialog";
import closeOrderDialog from "@/views/dialogCommon/closeOrderDialog.vue";
import OrderFinishOrRejectDialog from "@/views/dialogCommon/OrderFinishOrRejectDialog.vue";
import orderRemark from "@/views/dialogCommon/orderRemarkDialog"
import mapDialog from '@/views/workorder/business/common/mapdialog';
import zhiPaiDialog from '@/views/dialogCommon/assignSiteDialog.vue';
import itemDialog from '@/views/dialogCommon/chanPinDialog.vue';
//取消审核
import cancelCheckDialog from "@/views/dialogCommon/orderCancelCheckDialog"
import book from "@/views/dialogCommon/bookDialog.vue";
import {mapGetters} from "vuex";
import DictValueShow from "@/components/formItem/dictValueShow.vue";
import dispatchEngineer from "@/views/dialogCommon/dispatchEngineer.vue"
import subcontractor from "@/views/dialogCommon/subcontractor.vue"
//完工确定
import completion from "@/views/dialogCommon/completionDialog.vue";
//完工确认
import completionComfirm from "@/views/dialogCommon/completComfirmDialog.vue";
//工单修改
import orderEditDialog from "@/views/workorder/business/center/orderEditDialog.vue";
// 用户评价
import recordDialog from "@/views/workorder/business/common/recordDialog.vue";
import OrderDetailDialog from "@/views/workorder/historicalData/historicalWorkOrder/detailsDialog.vue";
import {editPageMixins} from "@/mixins/tabChang";
import OrderJudgingDialog from "@/views/workorder/business/complaintHandling/judgingDialog.vue";
import OrderComplaintHandlingDialog from "@/views/workorder/business/complaintHandling/complaintHandlingDialog.vue";
// <!-- 回访记录弹窗 -->
import showDetailsDialog from "@/views/dialogCommon/recordsDetailsDialog.vue";
// 关联工单共用弹出层
import commonDetails from "../../business/common/commonDetails.vue";
const cityOptions = ['挂壁式（5100W＜Q）变频', '挂壁式（3600W＜Q≤5100W）变频', '挂壁式（Q＜3200W）', '挂壁式 3200W≤Q≤3600W 变频'];
const cityOptions2 = ['挂壁式1变频', '挂壁式222变频', '挂壁式3', '挂壁式 4'];
export default {
  mixins: [editPageMixins],
  name: 'inheritEdit',
  props: {
    _dataId: [String, Number],
    dealType: {
      type: Boolean,
      default: false
    },
    selectType: [String, Number],
    pageType: {},
  },
  components: {
    commonDetails,
    showDetailsDialog,
    OrderComplaintHandlingDialog,
    OrderJudgingDialog,
    OrderDetailDialog,
    dispatchEngineer,
    subcontractor,
    book,
    completionComfirm,
    completion,
    DictValueShow,
    Tinymce,
    expenseDialog,
    assignDialog,
    closeOrderDialog,
    orderRemark,
    mapDialog,
    zhiPaiDialog,
    OrderFinishOrRejectDialog,
    itemDialog,
    cancelCheckDialog,
    orderEditDialog,
    recordDialog

  },
  data() {
    return {
      showCommonDetails: false,

      showDetailsDialog: false,
      showOrderDetailDialog: false,  // 工单弹窗显示标识符
      associateDocumentId: null,  // 关联单据id

      showOrderJudgingDialog: false,
      showOrderComplaintHandlingDialog: false,

      recordDialog2: false,
      more: false,
      getBuyChannelListUrl: '/basic/basBuyChannel/getList',
      dispatchEngineerDialog: false,
      completionDialog: false,
      completComfirmDialog: false,
      bookDialog: false,
      subcontractorDialog: false,
      showAssignDialog: false,
      showAssignByMapDialog: false,
      showCloseOrderDialog: false,
      showOrderFinishOrRejectDialog: false,
      showOrgDialog: false,
      showOrderRemaekDialog: false,
      showItemDialog: false,
      showCancelCheckDialog: false,
      showOrderEditDialog: false,
      lineIndex: 0,
      assginType: 0,
      orderRemarkParam: {},
      assignSiteParam: {},
      isFinishOrReject: 1,
      //权限管理
      orderSearchAndShow: false,
      assignOrg: false,
      orderEdit: false,
      assignSite: false,
      orderClose: false,
      assignSiteByMap: false,
      orderFollowUp: false,
      orderFinish: false,
      recordDialog: false,
      cancelCheck: false,
      assignAgain: false,

      changeBookReasonList: [],
      buyChannelOptions: [],

      // complaintPropertyList: [],
      // dutyJudgeList: [],
      // dutyJudgeSubList: [],
      // handleModelList: [],
      // consultTypeList: [],
      // consultTypeSubList: [],
      // praiseTypeList: [],

      show3: false,
      node: true,
      initiateAppeal: false,
      initiateAppealOrg: false,
      initiateAppealCompany: false,
      form2: {
        appealRemark: '',
      },
      loading: false,
      fileList: [],
      formLabelWidth: '80px',
      formData: {
        orderNo: '', // 工单号,前缀"SO"+年月日+6位流水号
        createType: 0, // 生成方式：0默认;1客服;2excel;3接口;4公众号;5PC自建单;6APP自建单;7服务中心;9其它;94苏宁帮客;95京东服务市场;97天猫服务市场;98京东测量服务;99京东ue平台;100京东3C
        orderTypeId: 0, // 工单来源ID,关联bas_order_type.id
        serverTypeId: 0, // 服务类型ID,关联bas_service_type.id
        userType: 0, // 用户类型:0普通用户、1售前机、2工程机、3VIP用户、4经销商
        userName: '', // 用户姓名
        userMobile: '', // 来电号码
        userPhone1: '', // 其他号码1
        userPhone2: '', // 其他号码2
        userProvice: '', // 省
        userCity: '', // 市
        userCounty: '', // 县
        userTown: '', // 镇街
        areaId: 0, // 地区ID,关联bas_area.id
        userAddress: '', // 详细地址
        longitude: 0, // 经度
        latitude: 0, // 纬度
        guaranteeType: 0, // 保修类型：1保内、2保外、3未知
        brandId: 0, // 品牌ID,关联sn_company_brand.id
        buyDate: '', // 购买时间
        buyShop: '', // 购买商场
        invoiceNo: '', // 发票号
        brarcode: '', // 报单条码
        outOrderNo: '', // 外部订单号
        complaintTypeId: 0, // 客诉类型ID,关联bas_customer_complaint_type.id
        issueFaultId: 0, // 客服录单故障现象id,关联bas_fault_symptom.id
        appeals: '', // 述求
        stat: 0, // 状态：1登记;2发布;5已派网点;9已派师傅;13已出发;17已上门;20完工暂存;21已完工;22网点确认完工;23中心确认完工;24总部确认完工;91待结算;92结算驳回;93结算中止;94已结算;98挂起;99取消
        dispatchStat: '', // 工单标签
        partsStat: 0, // 配件状态：0无配件;1申请；2审核；3出库；4网点收货；8驳回；9取消；11更换；12网点返厂；13返厂确认
        recallStat: 0, // 回访状态：0未回访、1已抽样、2已回访;5用户已评价
        siteComplainStat: 0, // 申诉状态：0无申诉；3待申诉；5已申诉；7中心已审核；8中心驳回；9总部已处理；99取消
        qualityStat: 0, // 质检状态：0未质检；1质检通过；2质检不通过；
        orgId: 0, // 业务机构，关联脚手架机构表sys_dept.dept_id
        orgName: '', // 机构名称,冗余字段
        orgIdPath: '', // 机构ID路径,冗余字段.重要
        siteId: 0, // 网点ID,关联sn_user.id;
        siteName: '', // 网点名称,冗余字段
        bigSiteId: null,
        bigSiteName: '',
        engineerId: 0, // 工程师Id,关联sn_site_engineer.id
        engineerName: '', // 工程师名称,冗余字段
        takeTime: null, // 派单时间
        takeEngineerTime: null, // 派工程师时间
        openId: '', // 消费者报修时关联的微信号id
        sysmtomId: 0, // 故障现象id,关联bas_fault_symptom.id
        reasonId: 0, // 故障原因id,关联bas_fault_reason.id
        methodId: 0, // 维修措施id,关联bas_fix_method.id
        isMustRecall: 0, // 是否必访:0否1是
        isCallRecall: 0, // 是否可抽样:0否1是
        isUrgent: 0, // 是否急单:0否1是
        isReplaceFinish: 0, // 是否重新完工：0否1是
        urgeTimes: 0, // 催单次数
        complainTimes: 0, // 投诉次数
        managerId: 0, // 督办人,关联sys_user.id
        outTransIn: 0, // 申请保外转保内:0否1是
        settleId: 0, // 结算单ID,关联sf_batch_settle.id字段
        sendPay: '', // sendPay:打标标识，未定义
        serverTypeName: null,
        orderTypeName: null,
        symptomName: null,
        reasonName: null,
        methodName: null,

        urger: null,

        associateDocuments: [],  // 关联单据

        soOrderExtendDTO: {
          wishBookDate: '', // 期望上门/安装时间
          deliverTime: '', // 到货签收时间
          finishMode: 0, // 完工模式：1结算密码；2上传图片；3图片+条码；9无验证完工
          finishType: 0, // 完工方式:1总部代完工;2网点PC端完工;3网点APP完工;4师傅APP完工;5接口完工;9其他
          commentLevel: 0, // 短信满意度：1非常满意;2满意;3一般;4不满意;5非常不满意
          isSendCommentMessage: 0, // 是否已发送评价短信：0否1是
          qualityMan: '', // 质检人
          qualityDate: '', // 质检时间
          qualityRemark: '', // 质检备注
          secondSiteComplain: 0, // 是否二次申诉：0否1是
          isInstallSynchro: 0, // 是否送装同步：0否1是
          hangupType: 0, // 挂起类型：0总部挂起；1网点挂起
          hangupReason: '', // 挂起原因
          sendFlag: 0, // 外部系统传单标识:0未传;1失败;2已传
          sendMessage: '', // 外部系统传单返回信息
          sendDate: '', // 外部系统传单时间
          thirdSendFlag: 0, // 传第三方网点接口状态:0未传;1失败;2已传
          thirdSendDate: '', // 传第三方网点接口时间
          thirdSendMessage: '', // 传第三方网点接口备注,如失败时用来保存失败的原因
          tmfworderid: '', // 天猫服务市场的工单ID
          tbcustomerid: '', // 天猫服务市场的用户ID
          commercePraise: 0, // 是否电商好评：0否1是

          complaintObjectName: '', // 投诉对象
          complaintProperty: null, // 投诉性质ID,关联脚手架数据字典项目表sys_dict_item.id
          dealSatisfaction: 0,
          dutyJudge: null, // 责任判定ID,关联脚手架数据字典项目表sys_dict_item.id
          dutyJudgeSub: null, // 责任细分ID,关联脚手架数据字典项目表sys_dict_item.id
          handleModel: null, // 处理方式ID,关联脚手架数据字典项目表sys_dict_item.id
          handlePlan: '', // 处理方案
          consultType: null, // 咨询类型ID,关联脚手架数据字典项目表sys_dict_item.id
          consultTypeSub: null, //  咨询细分ID,关联脚手架数据字典项目表sys_dict_item.id
          praiseObjectName: '', //  表扬对象
          praiseType: null, //  表扬类型ID,关联脚手架数据字典项目表sys_dict_item.id
          praiseJudge: 0, //   表扬是否成立:0否1是
          rewardJudge: 0, //  奖励是否成立:0否1是

          complaintPropertyName: null,
          isIntransfer: null,
          dealSatisfactionName: null,
          dutyJudgeName: null,
          dutyJudgeSubName: null,
          handleModelName: null,
          consultTypeName: null,
          consultTypeSubName: null,
          praiseTypeName: null,
          proServiceSubject: null,
          timeCheckText: null,
          urgeRecordText: null,
          traceRecordText: null,
        },
        soOrderProcessDTO: {
          orderId: 0, // 工单id，关联so_order.id
          takeOrgTime: '', // 派中心时间
          // takeTime: '', // 派单时间
          acceptOperateTime: '', // 网点确认接单时间
          // takeEngineerTime: '', // 派工程师时间
          engineerAcceptOperateTime: '', // 工程师确认接单时间
          firstBookOperateTime: '', // 首次预约操作时间
          firstBookDate: '', // 首次预约时间
          bookOperateTime: '', // 预约操作时间
          bookDate: '', // 预约时间
          startOffTime: '', // 出发时间
          onDoorTime: '', // 上门签到时间
          onDoorLocation: '', // 上门签到地址
          firstCompleteTime: '', // 首次完工时间
          completeTime: '', // 完工时间
          onTimeLocation: '', // 完工地址
          siteComfirmTime: '', // 网点确认完工时间
          orgComfirmTime: '', // 中心确认完工时间
          officeComfirmTime: '', // 总部确认完工时间
          recallTime: '', // 回访时间
          complaintProcessTimes: 0, // 客诉跟进次数
          complaintProcesser: '', // 客诉跟进人
          complaintProcessDate: '', // 客诉跟进时间
          siteComplaintProcessDate: '', // 网点客诉跟进时间
          applyPayDate: '', // 进入结算池时间
          payDate: '', // 提交结算时间
          cancleDate: '', // 取消/退单时间
          returnId: 0, // 取消/退单原因：关联bas_return_type.id.
          returnName: null, // 取消/退单原因：关联bas_return_type.id.
          finishNote: '', // 完工备注
          comfirmNote: '', // 完工审核备注
          fixStatus: 0,//维修状态
          bookTimes: 0,//预约次数
          changeBookReason: null,  // 改约原因
        },
        soOrderCommentDTO: {
          speed: 0,  // 响应速度评分
          effect: 0,  // 服务效果评分
          fee: 0,  // 合理收费评分
          other: null,  // 其他评价
          pic1: null,  // 图片1
          pic2: null,  // 图片2
          pic3: null,  // 图片3
          topLevel: 0,  // 总体评价:1非常满意;2满意;3一般;4不满意;5非常不满意
          question1: null,  // 问题1描述
          question1Answer: 0,  // 问题1答案:0否1是
          question2: null,  // 问题2描述
          question2Answer: 0,  // 问题2答案:0否1是
          question3: null,  // 问题3描述
          question3Answer: 0,  // 问题4答案:0否1是
          question4: null,  // 问题4描述
          question4Answer: 0,  // 问题4答案:0否1是
          sources: 0,  // 评价来源:1电商接口;2短信回复评价;3用户微信评价;4APP扫码评价
        },
        soOrderSettleDTO: {
          siteFinalAmount: null,
          siteAmount: null,
          rewardAmount: null,
          mapLongDistance: null,
          longDistance: null,
          longDistanceAmount: null,
          userPayType: null,
          userPayName: null,
          userPayAccount: null,
          userPayStat: null,
          userPayNo: null,
          userPayTime: null,
          userPayStatMsg: null,
          productDate: null,
          installDate: null
        },
        soOrderResultDTO: {
          inCode: null,
          outCode: null,
          finishPic1: null,
          srcList1: [],
          finishPic2: null,
          finishPic3: null,
          finishPic4: null,
          finishPic5: null,
          finishPic6: null,
        },
        soOrderCommentDTOList: [{}],
        soRecallHistoryDTOList: [{}],
        soOrderComplainDTOList: [],
        soOrderLineDTOList: [{}],
        soOrderPartsDTOList: [],
        soOrderPreconditionResultDTOList: [],
        soOrderOperationDTOList: [],
        soOrderSlaList: [],
        sfCheckBillDTOList: [],
        soOrderFaultDTOList: [],
        soOrderFeeAttributeList: []
      },
      dataList: [],
      srcList: [],

      soOrderSpecailFeeListToUser: [],
      soOrderSpecailFeeListToCompany: [],
      ////////////////////////////////////////////////////////////////////////////////////////////
      card: true,
      areaProps: {
        lazy: true,
        emitPath: false,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      areaValues: [],
      areaOption: [],
      showPreconditionDialog: false,
      checkAll: false,
      checkAll2: false,
      checkedCities: ['挂壁式（5100W＜Q）变频', '挂壁式（3600W＜Q≤5100W）变频'],
      checkedCities2: ['挂壁式1变频',],
      cities: cityOptions,
      cities2: cityOptions2,
      isIndeterminate: true,
      isIndeterminate2: true,
      // 以上卡片数据
      //  第四个页面表---服务类型
      table_area: [{
        companyId: 1,
        areaName: '空调',
        areaCode: '333',
        areaLevel: '中国广东省佛山市顺德区北滘镇',
        settleLevel: '维修投诉',
        code1: 'aaa',
        code2: 'bbbb',
        usable: 0,
      }, {
        companyId: 2,
        areaName: '冰箱',
        areaCode: '2222',
        areaLevel: '中国广东省佛山市顺德乐从镇',
        settleLevel: 0,
        code1: 'aaa222',
        code2: 'bbbb222',
        usable: 1,
      }],
      //  第五个页面表---服务类型
      table_type: [{
        typeName: '维修投诉',
        usable: '启用',
      }, {
        typeName: '安装投诉',
        usable: '禁止',
      }, {
        typeName: '售前机维修外机',
        usable: '启用',
      }],
      img_b: "",
      //认证信息-- 资质照片-测试数据

      big_img: [
        'https://bkimg.cdn.bcebos.com/pic/80cb39dbb6fd5266d0168fdb9654802bd40734fa98e2?x-bce-process=image/resize,m_lfit,w_536,limit_1'
      ],
      // showParameterDialog: false,
      showSaleConfigDialog: false,
      upload_btn: false, // 是否隐藏上传图片按钮
      upload_btn4: false, // 是否隐藏上传图片按钮
      radio: 1,
      isSite: null,
      showEdit: false,
      valuetype: 'model',
      textarea: '',
      //  value1: true,
      value2: false,
      value3: true,
      activeName: 'first',
      activeName2: 'first',
      activeName3: '1',

      dialog: {
        one: false,
      },
      lan: 'zh_CN',
      isEdit: false,
      tabIndex: 'first',
      dataId: '',
      _dealType: '',
      _selectType:0,
      tenant: {
        snCompanyOrderAttributeDTOS: [],
        url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',

        // 评分
        fen: 3.6,
        fen2: 4.5,
        fen3: 5.0,
        contractFile: [],
        longitude: '东经160度',
        latitude: "北纬60度",
        stat: 1,
        siteType: 2,
        siteFloorLevel: 1,
        siteOverAllArea: 0,
        isAutoIssue: 0,
        siteInvoiceRate: 0,
        siteAutoAccept: 0,
        checkBeyondBookdate: 0,
        autoComfirmOrder: 0,
        siteInvoiceType: 0,
        abilityPhoto: [{
          name: '用户照片',
          url: 'https://bkimg.cdn.bcebos.com/pic/7dd98d1001e93901213fb5162da043e736d12f2e38cd?x-bce-process=image/resize,m_lfit,w_536,limit_1'
        },],
        // 门头照片
        shopPhoto: [],
        //营业执照照片
        businessPhoto: [],
        // 基本信息-用户图片
        userPhoto: [{
          name: '用户照片',
          url: 'https://bkimg.cdn.bcebos.com/pic/80cb39dbb6fd5266d0168fdb9654802bd40734fa98e2?x-bce-process=image/resize,m_lfit,w_536,limit_1'
        },],
        status: 1,
        tenantAttachmentDTOs: []
      },
      showProductCategoryDialog: false,
      languageDTOs: [],
      dialogImageUrl: '',
      dialogVisible: false,
      uploadDisabled: false,
      upload_img: [

        // imageList: [], //图片数据列表,用于之后上传到后端
        // imageName: []  //图片名称
      ],

      //地址选择
      selectemp: {},
      selectedOptions: [],
      options: regionData,
      // 费用配置表

      tableData3: [{
        brandName: '预审项目1',
        tag: '家',
        usable: '必访',
      }, {
        brandName: '预审项目22',
        tag: '公司',
        usable: '申诉',
      }, {
        brandName: '预审项目333',
        tag: '公司',
        usable: '挂起',
      }, {
        brandName: '预审项目44',
        tag: '公司',
        usable: '重新完工',
      }],
    };
  },
  computed: {
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId ? tenantId : '1'
      };
    },
    ...mapGetters(["permissions"])
  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    this._dealType = this.dealType
    this._selectType = this.selectType
    console.log(this._dealType, "dealType的值");

    this.assignOrg = this.permissions["assignOrg"];
    this.orderEdit = this.permissions["orderEdit"];
    this.assignSite = this.permissions["assignSite"];
    this.assignSites = this.permissions["assignSites"];
    this.orderClose = this.permissions["orderClose"];
    this.assignSiteByMap = this.permissions["assignSiteByMap"];
    this.orderFollowUp = this.permissions["orderFollowUp"];
    this.orderFinish = this.permissions["orderFinish"];
    this.centerReview = this.permissions["centerReview"];
    this.initiateAppealA = this.permissions["initiateAppeal"];
    this.headquartersReview = this.permissions["headquartersReview"];
    this.abandonAppeal = this.permissions["abandonAppeal"];
    this.cancelCheck = this.permissions["cancelCheck"]
    this.assignAgain = this.permissions["assignAgain"]
    // console.log(this.tenant,"tenant的值");
    const userInfo = store.getters.userInfo;
    if (userInfo.snUserId) {
      this.isSite = true;
    }
    console.log("是否为服务商" + this.isSite)
  },
  mounted() {
    console.log(this._selectType, "_selectType的值"+this.dataId);
    // this.initTableList();
    //this.loadBuyChannelOption();
    this.getData();
  },
  methods: {

    closeD(v) {
      this.showCommonDetails = v
    },
    showDetails(id, row) {
      console.log(id, row, "点击的数据")
      this.row2 = row
      this.workNumber = id
      this.showDetailsDialog = true

    },

    closeD2(v) {
      // this.reload()
      console.log(v, "v的值");
      this.showDetailsDialog = v

    },

    // 关联单据弹窗
    // 关联单据弹窗
    openDocumentNumber(type, id,row) {
      console.log(type, id,row, "type, id的值");
      this.associateDocumentId = id
      if ('上游工单' === type) {
        this.showOrderDetailDialog = true
      } else if ('配件返厂' === type) {
        console.log('配件返厂222', type);
        this.row11 = id
        this.typeName = type
        this.processId=row.processId

        this.showCommonDetails = true

      } else if ('质量报告' === type) {
        console.log('质量报告222', type);
        this.row11 = id
        this.typeName = type
        this.processId=row.processId

        this.showCommonDetails = true

      } else if ('事故报告' === type) {
        console.log('事故报告222', type);
        this.row11 = id
        this.typeName = type
        this.processId=row.processId

        this.showCommonDetails = true

      }
      else if ('配件申请' === type) {
        console.log('配件申请222', type);
        this.row11 = id
        this.typeName = type
        this.processId=row.processId

        this.showCommonDetails = true

      } else if ('退换货单' === type) {
        console.log('退换货单222', type);
        this.row11 = id
        this.typeName = type
        this.processId=row.processId


        this.showCommonDetails = true

      }
    },

    openRecordDialog2(e) {

      this.evaluate = e
      this.recordDialog2 = true

    },
    //指派中心
    doAssignOrg() {
      this.showOrgDialog = true;
    },
    commitOrgSelect(data) {
      this.$http({
        url: api.soOrder.assignOrgUrl,
        method: 'post',
        data: {
          orgId: data.id,
          id: data.orderId,
          orgName: data.name,
          orgIdPath: data.orgIdPath
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.$message({
          type: response.data.type,
          message: response.data.content
        });
        this.reload()// 需要刷新页面
      })
    },
    //列表指派
    doAssignSite() {
      this.assginType = 0
      this.showAssignDialog = true;
    },
    commitSiteRow(row) {
      this.$http({
        url: api.soOrder.assignSiteUrl,
        method: 'post',
        data: {
          orderId: this.dataId,
          orderIds: this.orderIds,
          siteId: row.id,
          type: row.callBackAssignType,
          isSendSite: row.isSendSite,
          isSendUser: row.isSendUser
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.$message({
          type: response.data.type,
          message: response.data.content
        });
        this.$emit('editViewDataUpdate')// 需要刷新页面
      })
    },
    //地图指派
    doAssignSiteByMap() {
      this.assginType = 2
      this.assignSiteParam.wishBookDate = this.formData.wishBookDate
      this.showAssignByMapDialog = true;
    },
    //重新派单
    doAssignAgain() {
      this.assginType = 3
      this.showAssignDialog = true;
    },
    //工单跟进
    doOrderFollowUp() {
      this.orderRemarkParam.showInRemark = 1
      this.orderRemarkParam.orderId = this.dataId
      this.showOrderRemaekDialog = true;
    },
    followUpOrderRemark(type) {
      this.showOrderRemaekDialog = false;
      if (type == 1) {
        this.$emit('editViewDataUpdate')// 需要刷新页面
      }
    },
    closeBook(type) {
      this.bookDialog = false;
      if (type == 1) {
        this.$emit('editViewDataUpdate')// 需要刷新页面
      }
    },
    doEditOrder() {
      this.showOrderEditDialog = true
    },
    closeEdit(type) {
      this.showOrderEditDialog = false;
      console.log("closeEdit===", type)
      if (type == 1) {
        this.$emit('editViewDataUpdate')// 需要刷新页面
      }
    },
    //关闭工单
    doOrderClose() {
      this.orderId = this.dataId;
      this.showCloseOrderDialog = true;
    },
    closeOrderRemark(type) {
      this.showCloseOrderDialog = false;
      if (type == 1) {
        this.$emit('editViewDataUpdate')// 需要刷新页面
      }
    },
    //取消审核
    toCancelCheck() {
      this.orderRemarkParam.orderId = this.dataId
      this.showCancelCheckDialog = true;
    },
    //取消审核回调方法
    doCancelCheck(type) {
      this.showCancelCheckDialog = false;
      if (type == 1) {
        this.$emit('editViewDataUpdate')// 需要刷新页面
      }
    },
    //确认完工
    doOrderFinish() {
      this.orderId = this.dataId;
      this.isFinishOrReject = 1;
      this.showOrderFinishOrRejectDialog = true;
    },
    // //驳回完工
    // doOrderReject() {
    //   this.orderId = this.dataId;
    //   this.isFinishOrReject = 2;
    //   this.showOrderFinishOrRejectDialog = true;
    // },
    closeDialog(type) {
      this.showOrderFinishOrRejectDialog = false;
      if (type == 1) {
        this.$emit('editViewDataUpdate')// 需要刷新页面
      }
    },

    //删除产品明细
    orderLineDetele(index) {
      if (this.formData.soOrderLineDTOList.length > 1) {
        this.formData.soOrderLineDTOList.splice(index, 1);
      } else {
        this.$message.warning('至少存在一条产品信息！');
      }
    },
    addListRow() {
      this.formData.soOrderLineDTOList.push({});
    },
    //选择产品
    selectItem(index) {
      console.log(this.formData.soOrderLineDTOList, " this.formData.soOrderLineDTOList")
      this.showItemDialog = true;
      this.lineIndex = index;
    },
    commitItemRow(row) {
      this.formData.soOrderLineDTOList[this.lineIndex].itemId = row.id
      this.formData.soOrderLineDTOList[this.lineIndex].itemCode = row.itemCode
      this.formData.soOrderLineDTOList[this.lineIndex].itemName = row.itemName
      this.formData.soOrderLineDTOList[this.lineIndex].qty = 1
      this.formData.soOrderLineDTOList[this.lineIndex].bigCategoryId = row.bigCategoryId
      this.formData.soOrderLineDTOList[this.lineIndex].bigCategoryName = row.bigCategoryName
      this.formData.soOrderLineDTOList[this.lineIndex].smallCategoryId = row.smallCategoryId
      this.formData.soOrderLineDTOList[this.lineIndex].smallCategoryName = row.smallCategoryName
      his.formData.soOrderLineDTOList[this.lineIndex].brandId = row.brandId
    },
    doEdit() {
      if (!this.formData.userName) {
        this.$message({ message: '用户名不能为空!', type: 'warning' });
        return;
      }
      if (!this.formData.areaId) {
        this.$message({ message: '用户地址不能为空!', type: 'warning' });
        return;
      }
      if (!this.formData.userAddress) {
        this.$message({ message: '用户详细地址不能为空!', type: 'warning' });
        return;
      }
      if (!this.formData.userMobile) {
        this.$message({ message: '用户号码不能为空!', type: 'warning' });
        return;
      }
      this.$baseConfirm('您确定要保存吗？').then(() => {
        this.$http({
          url: api.soOrder.doEditUrl,
          method: 'post',
          data: this.formData,
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          if (response.data.type == "success") {
            this.$message({ message: response.data.content, type: 'success' });
            this.$emit('editViewDataUpdate')
          } else {
            this.$message({ message: response.data.data, type: 'warning' });
          }
        })
      })
    },


    openRecordDialog(e) {

      console.log(e, "点击的权益id");
      this.areaObj3 = e
      this.recordDialog = true

    },
    handleClick(tab, event) {
      console.log(tab, event);
      console.log(tab.name, "name得值");
      if (tab.index == 0) {
        this.card = true
      } else {
        this.card = false
      }


    },

    // 加载购买渠道
    loadBuyChannelOption() {
      this.$http({
        url: this.getBuyChannelListUrl,
        method: 'post',
        data: {
          buyChannelName: null
        }
      }).then(res => {
        this.buyChannelOptions = []
        res.data.data.forEach(item => {
          this.buyChannelOptions.push({
            label: item.buyChannelName,
            value: item.id
          })
        })
      })
    },

    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      this.formData.areaId = node.value;
      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        if (node.root) {
          const childrens = response.data.data || {};
          const childNodes = childrens.map(item => ({
            value: item.id,
            label: item.areaName,
            leaf: Number(item.hasChild) !== 0
          }))
          // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          resolve(childNodes);
        } else {
          const childrens = response.data.data || {};
          let childNodes = []
          let temp = ''
          if (node.children.length !== 0) {
            temp = node.children
            childrens.forEach(item => {
              let flag = false
              temp.forEach(item1 => {
                if (item1.value == item.id) {
                  flag = true  // 当前节点已存在此数据，不追加
                }
              })
              if (!flag) {
                childNodes.push({
                  value: item.id,
                  label: item.areaName,
                  leaf: Number(item.hasChild) !== 0
                })
              }
            })
            resolve(childNodes);
          } else {
            childrens.forEach(item => {
              childNodes.push({
                value: item.id,
                label: item.areaName,
                leaf: Number(item.hasChild) !== 0
              })
            })
            resolve(childNodes);
          }
        }
      })
    },
    loadDictData() {
      // // 改约原因
      // loadDictData("change_book_reason").then(res => {
      //   this.changeBookReasonList = []
      //   res.data.data.forEach(item => {
      //     this.changeBookReasonList.push({
      //       label: item.label,
      //       value: item.id
      //     })
      //   })
      // })


      // @ApiModelProperty(value = "投诉性质ID,关联脚手架数据字典项目表sys_dict_item.id")
      // private Long complaintProperty;

      // @ApiModelProperty(value = "责任判定ID,关联脚手架数据字典项目表sys_dict_item.id")
      // private Long dutyJudge;

      // @ApiModelProperty(value = "责任细分ID,关联脚手架数据字典项目表sys_dict_item.id")
      // private Long dutyJudgeSub;

      // @ApiModelProperty(value = "处理方式ID,关联脚手架数据字典项目表sys_dict_item.id")
      // private Long handleModel;

      // @ApiModelProperty(value = "咨询类型ID,关联脚手架数据字典项目表sys_dict_item.id")
      // private Long consultType;

      // @ApiModelProperty(value = "咨询细分ID,关联脚手架数据字典项目表sys_dict_item.id")
      // private Long consultTypeSub;

      // @ApiModelProperty(value = "表扬类型ID,关联脚手架数据字典项目表sys_dict_item.id")
      // private Long praiseType;
      // loadDictData("complaint_property").then(res => {
      //   this.complaintPropertyList = []
      //   res.data.data.forEach(item => {
      //     this.complaintPropertyList.push({
      //       label: item.label,
      //       value: item.id
      //     })
      //   })
      // })
      // loadDictData("duty_judge").then(res => {
      //   this.dutyJudgeList = []
      //   res.data.data.forEach(item => {
      //     this.dutyJudgeList.push({
      //       label: item.label,
      //       value: item.id
      //     })
      //   })
      // })
      // loadDictData("duty_judge_sub").then(res => {
      //   this.dutyJudgeSubList = []
      //   res.data.data.forEach(item => {
      //     this.dutyJudgeSubList.push({
      //       label: item.label,
      //       value: item.id
      //     })
      //   })
      // })
      // loadDictData("handle_model").then(res => {
      //   this.handleModelList = []
      //   res.data.data.forEach(item => {
      //     this.handleModelList.push({
      //       label: item.label,
      //       value: item.id
      //     })
      //   })
      // })
      // loadDictData("consult_type").then(res => {
      //   this.consultTypeList = []
      //   res.data.data.forEach(item => {
      //     this.consultTypeList.push({
      //       label: item.label,
      //       value: item.id
      //     })
      //   })
      // })
      // loadDictData("consult_type_sub").then(res => {
      //   this.consultTypeSubList = []
      //   res.data.data.forEach(item => {
      //     this.consultTypeSubList.push({
      //       label: item.label,
      //       value: item.id
      //     })
      //   })
      // })
      // loadDictData("praise_type").then(res => {
      //   this.praiseTypeList = []
      //   res.data.data.forEach(item => {
      //     this.praiseTypeList.push({
      //       label: item.label,
      //       value: item.id
      //     })
      //   })
      // })
    },

    saveData() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            this.$mask.open()

            var url = (this.isEdit ? `/admin/fwpttenant/update` : `/admin/fwpttenant/save`);
            request({
              url: url,
              method: 'post',
              data: this.tenant,
              isLoading: true,
            }).then(response => {
              this.$message({
                message: response.data.content,
                type: 'success',
                duration: 500,
                onClose: t => {
                  if (this.isEdit) {
                    this.$baseReload();
                    this.$mask.close()

                  } else {
                    this.$baseReload({
                      updateParam: {
                        _dataId: response.data.objx
                      }
                    });
                    this.$mask.close()

                  }
                }
              });
            });
          });
        }
      });
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    handleCheckAllChange(val) {
      this.checkedCities = val ? cityOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
    },
    radioHandleChange(val) {
      if (val == 1) {
        this.radio = 1
      } else if (val == 2) {
        this.radio = 2
      }
    },
    // 地址三级联动
    handleChange() {
      const areaNode = this.$refs["cascaderAddr"].getCheckedNodes();
      if (areaNode != null && areaNode[0] != null && areaNode[0].value != null) {
        this.formData.areaId = areaNode.value;
        if (areaNode[0].level == 1) {
          this.formData.userProvice = null;
          this.formData.userCity = null;
          this.formData.userCounty = null;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 2) {
          this.formData.userProvice = areaNode[0].label;
          this.formData.userCity = null;
          this.formData.userCounty = null;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 3) {
          this.formData.userCity = areaNode[0].label;
          this.formData.userCounty = null;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 4) {
          this.formData.userCounty = areaNode[0].label;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 5) {
          this.formData.userTown = areaNode[0].label;
        }
      } else {
        this.formData.areaId = null;
        this.formData.userProvice = null;
        this.formData.userCity = null;
        this.formData.userCounty = null;
        this.formData.userTown = null;
      }
      const panelRefs = this.$refs.cascaderAddr.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      }

    },
    cancelForm() {
      this.loading = false;
      this.initiateAppeal = false;
      this.initiateAppealOrg = false;
      this.initiateAppealCompany = false;
      clearTimeout(this.timer);
    },
    abandonAppeal() {
      this.$confirm('是否放弃申诉,该工单将挂起并取消结算？')
        .then(_ => {
          this.$http({
            url: api.soOrder.abandonAppeal,
            method: 'post',
            data: {
              id: this._dataId,
            }
          }).then(res => {
            this.$message.success('操作成功')
            this.flushed()
          })
        })
        .catch(_ => {
          this.cancelForm();
        });
    },
    getData() {
      // this.$mask.open()

      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.inheritSiteOrder.getDataUrl,
          method: 'post',
          data: {
            orderId: this.dataId,
            selectType: this._selectType,
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.formData = response.data.data
          // this.$mask.close()

          const soOrderSpecailFeeList = response.data.data.soOrderSpecailFeeDTOList
          console.log("此处费用列表数量--" + soOrderSpecailFeeList.length)
          this.soOrderSpecailFeeListToCompany = [];
          this.soOrderSpecailFeeListToUser = [];
          soOrderSpecailFeeList.forEach(item => {
            if (item.feeType == 1) {
              this.soOrderSpecailFeeListToCompany.push(
                {
                  subjectName: item.subjectName,
                  qty: item.qty,
                  price: item.price,
                  amount: item.amount,
                  unit: item.unit
                }
              )
            } else if (item.feeType == 2) {
              this.soOrderSpecailFeeListToUser.push(
                {
                  subjectName: item.subjectName,
                  qty: item.qty,
                  price: item.price,
                  amount: item.amount,
                  unit: item.unit
                }
              )
            }
          })

          this.srcList.push(this.formData.soOrderResultDTO.finishPic1)
          // this.srcList1=this.formData.soOrderResultDTO.finishPic1
          this.srcList.push(this.formData.soOrderResultDTO.finishPic2)
          this.srcList.push(this.formData.soOrderResultDTO.finishPic3)
          this.srcList.push(this.formData.soOrderResultDTO.finishPic4)
          this.srcList.push(this.formData.soOrderResultDTO.finishPic5)
          this.srcList.push(this.formData.soOrderResultDTO.finishPic6)
          this.srcList.push(this.formData.soOrderResultDTO.finishPic7)
          console.log(this.srcList, "this.srcList1的值");
          this.orderRemarkParam.orderId = this._dataId;
          this.orderRemarkParam.showInRemark = 1
          if (this.formData.soOrderComplainDTOList != null && this.formData.soOrderComplainDTOList.length != 0) {
            this.formData.soOrderComplainDTOList.forEach(item => {
              let list = []
              if (item.fileUrl1 != null) {
                list.push(item.fileUrl1)
              }
              if (item.fileUrl2 != null) {
                list.push(item.fileUrl)
              }
              if (item.fileUrl3 != null) {
                list.push(item.fileUrl3)
              }
              item.srcList = list
            })
          }
          if (this.formData.sfCheckBillDTOList != null && this.formData.sfCheckBillDTOList.length != 0) {
            this.formData.sfCheckBillDTOList.forEach(item => {
              if (item.stat == 1) {
                item.stat = '制单';
              } else if (item.stat == 2) {
                item.stat = '待确认';
              } else if (item.stat == 3) {
                item.stat = '待申诉';
              } else if (item.stat == 5) {
                item.stat = '已申诉';
              } else if (item.stat == 7) {
                item.stat = '执行考核';
              } else if (item.stat == 9) {
                item.stat = '已结算';
              } else if (item.stat == 19) {
                item.stat = '取消执行';
              } else if (item.stat == 99) {
                item.stat = '关闭';
              }
            })
          }
          // if (this.formData.buyChannelId) {
          //   console.log('278365782346578234785')
          //   this.buyChannelOptions.forEach(item => {
          //     if (item.id === this.formData.buyChannelId) {
          //       this.formData.buyChannelName = item.buyChannelName
          //     }
          //   })
          // }
          // if (!!this.formData.soOrderProcessDTO) {
          //   if (!!this.formData.soOrderProcessDTO.changeBookReason) {
          //     this.changeBookReasonList.forEach(item => {
          //       if (item.id === this.formData.soOrderProcessDTO.changeBookReason) {
          //         this.formData.soOrderProcessDTO.changeBookReasonName = item.label
          //       }
          //     })
          //   }
          // }


          // if (!!this.formData.soOrderExtendDTO) {
          //   if (!!this.formData.soOrderExtendDTO.complaintProperty) {
          //     this.complaintPropertyList.forEach(item => {
          //       if (item.id === this.formData.soOrderExtendDTO.complaintProperty) {
          //         this.formData.soOrderExtendDTO.complaintPropertyName = item.label
          //       }
          //     })
          //   }
          //   if (!!this.formData.soOrderExtendDTO.dutyJudge) {
          //     this.dutyJudgeList.forEach(item => {
          //       if (item.id === this.formData.soOrderExtendDTO.dutyJudge) {
          //         this.formData.soOrderExtendDTO.dutyJudgeName = item.label
          //       }
          //     })
          //   }
          //   if (!!this.formData.soOrderExtendDTO.dutyJudgeSub) {
          //     this.dutyJudgeSubList.forEach(item => {
          //       if (item.id === this.formData.soOrderExtendDTO.dutyJudgeSub) {
          //         this.formData.soOrderExtendDTO.dutyJudgeSubName = item.label
          //       }
          //     })
          //   }
          //   if (!!this.formData.soOrderExtendDTO.handleModel) {
          //     this.handleModelList.forEach(item => {
          //       if (item.id === this.formData.soOrderExtendDTO.handleModel) {
          //         this.formData.soOrderExtendDTO.handleModelName = item.label
          //       }
          //     })
          //   }
          //   if (!!this.formData.soOrderExtendDTO.consultType) {
          //     this.consultTypeList.forEach(item => {
          //       if (item.id === this.formData.soOrderExtendDTO.consultType) {
          //         this.formData.soOrderExtendDTO.consultTypeName = item.label
          //       }
          //     })
          //   }
          //   if (!!this.formData.soOrderExtendDTO.consultTypeSub) {
          //     this.consultTypeSubList.forEach(item => {
          //       if (item.id === this.formData.soOrderExtendDTO.consultTypeSub) {
          //         this.formData.soOrderExtendDTO.consultTypeSubName = item.label
          //       }
          //     })
          //   }
          //   if (!!this.formData.soOrderExtendDTO.praiseType) {
          //     this.praiseTypeList.forEach(item => {
          //       if (item.id === this.formData.soOrderExtendDTO.praiseType) {
          //         this.formData.soOrderExtendDTO.praiseTypeName = item.label
          //       }
          //     })
          //   }
          // }

          if (this.formData.soOrderFeeAttributeList) {
            this.dataList = []
            let flag = 0
            let temp = []
            this.formData.soOrderFeeAttributeList.forEach(item => {
              if (flag < 4) {
                flag += 1
              } else {
                this.dataList.push(temp)
                flag = 0
                temp = []
              }
              temp.push({ key: item.feeAttributeName, value: item.amount })
            })
            if (temp.length > 0) {
              this.dataList.push(temp)
            }
          }
          if (this.dealType == 'orderEdit' && this.formData.areaId != null && this.formData.areaId != '') {
            this.$http({
              url: api.basArea.echoAddressUrl,
              method: 'post',
              data: { id: this.formData.areaId }
            }).then(res => {
              this.areaOption = res.data.data.options
              this.areaValues = res.data.data.values
            })
          }
        })
      } else {
        this.enabled = true;
      }
    },

    async toInitiateAppeal(userType) {
      try {
        this.loading = true;
        // 发送请求
        if (userType == 'site') {
          const res = await axios.post(api.soOrder.toInitiateAppeal, {
            appealType: 1,
            orderId: this._dataId,
            appealRemark: this.form2.appealRemark,
            piclist: this.fileList
          });
          if (res.data) {
            // 确保 el-drawer 组件已经初始化完成再关闭该窗口
            // this.$nextTick(() => {
            //   this.$refs.drawer.closeDrawer();
            // });
            this.$message.success('操作成功！');
            this.fileList = [];
            this.form2.appealRemark = '';
            this.cancelForm()
            this.getData();
          } else {
            this.$message.error('操作失败，请稍后重试');
          }
        } else if (userType == 'org') {
          const res = await axios.post(api.soOrder.toInitiateAppeal, {
            appealType: 2,
            radio: this.radio,
            orderId: this._dataId,
            appealRemark: this.form2.appealRemark,
            piclist: this.fileList
          });
          if (res.data) {
            // 确保 el-drawer 组件已经初始化完成再关闭该窗口
            // this.$nextTick(() => {
            //   this.$refs.drawer.closeDrawer();
            // });
            this.$message.success('操作成功！');
            this.fileList = [];
            this.form2.appealRemark = '';
            this.cancelForm()
            this.getData();
          } else {
            this.$message.error('操作失败，请稍后重试');
          }
        } else if (userType == 'company') {
          const res = await axios.post(api.soOrder.toInitiateAppeal, {
            appealType: 3,
            radio: this.radio,
            orderId: this._dataId,
            appealRemark: this.form2.appealRemark,
            piclist: this.fileList
          });
          if (res.data) {
            // 确保 el-drawer 组件已经初始化完成再关闭该窗口
            // this.$nextTick(() => {
            //   this.$refs.drawer.closeDrawer();
            // });
            this.$message.success('操作成功！');
            this.fileList = [];
            this.form2.appealRemark = '';
            this.cancelForm()
            this.getData();
          } else {
            this.$message.error('操作失败，请稍后重试');
          }
        }
      } catch (error) {
        // console.error(error);
        // this.$message.error('系统错误，请稍后重试');
      } finally {
        this.loading = false;
      }
    },
    handleClose(done) {
      if (this.loading) {
        return;
      }
      this.$confirm('是否关闭操作窗？')
        .then(_ => {
          // this.loading = true;
          done();
          this.cancelForm()
          // this.timer = setTimeout(() => {
          //   done();
          //   // 动画关闭需要一定的时间
          //   setTimeout(() => {
          //     // this.loading = false;
          //     this.cancelForm()
          //   }, 400);
          // }, 1000);
        })
        .catch(_ => {
          this.cancelForm()
        });
    },
    preconditionconfirm(rows) {
      if (rows.length > 0) {

        const tableData = this.table_type;
        const map = {};
        tableData.forEach(function (item) {
          map[item.preconditionId] = 1;
        });
        var items = [];
        rows.forEach((row, index) => {
          const item = {
            preconditionId: row.id,
            typeName: row.precondition
          };
          if (!map[item.preconditionId]) {
            items.push(item);
          }
        });
        this.table_type = this.table_type.concat(items);
      }
    },
    // 删除所选的数据  2表
    handleDelete1_2(index) {
      this.tenant.snCompanyOrderAttributeDTOS.splice(index, 1);
    },
    AddListRow1_2() {

      this.tenant.snCompanyOrderAttributeDTOS.push({})
    },

    //申诉上传图片操作
    handleSuccessAppeal(res, file, fileList) {
      this.fileList.push(res.data.url)
    },
    handleRemoveAppeal(file, fileList) {
      console.log(file, fileList);
    },
    handlePreviewAppeal(file) {
      console.log(file);
    },
    handleExceedAppeal(files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemoveAppeal(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },


    // 上传成功
    handleSuccess(response, file) {
      // 上传成功后，隐藏上传按钮
      this.upload_btn = true;
      // this.tenant.snCompanyBrandDTOS[picIndex].pic = res.data.url;
      // Vue.set(this.tenant.shopPhoto, 'pic', res.data.url)

    },
    handleRemove(response, file) {
      // 上传成功后，显示上传按钮
      this.upload_btn = false;
    },

    // 上传成功
    handleSuccess4(res, file, picIndex) {
      // 上传成功后，隐藏上传按钮
      this.upload_btn4 = true;
      // this.tenant.snCompanyBrandDTOS[picIndex].pic = res.data.url;
      Vue.set(this.tenant.businessPhoto,)

    },
    handleRemove4(response, file) {
      // 上传成功后，显示上传按钮
      this.upload_btn4 = false;
    },
    handleDelete2(index) {
      this.table_area.splice(index, 1);
    },
    handleDelete(index) {
      this.table_type.splice(index, 1);
    },

    //网点接单
    siteAccept(row) {
      this.$baseConfirm('是否确认接单？').then(() => {
        this.$http({
          url: api.soOrder.siteAcceptUrl,
          method: 'post',
          data: {
            id: this._dataId,
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.$message({
            type: response.data.type,
            message: response.data.content
          });
          this.flushed()
        })
      });
    },

    // 派工程师
    closeDispatchEngineer(type) {
      this.dispatchEngineerDialog = false;
      if (type == 1) {
        this.reload()// 需要刷新页面
      }
    },

    //派下级商
    closeSubcontractor(type) {
      this.subcontractorDialog = false;
      if (type == 1) {
        this.reload()// 需要刷新页面
      }
    },
    //取消挂起
    cancelOrder(row) {
      this.$baseConfirm('您确定要取消挂起工单吗？').then(() => {
        this.$http({
          url: api.soOrder.cancelOrderUrl,
          method: 'post',
          data: {
            id: this._dataId,
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.$message({
            type: response.data.type,
            message: response.data.content
          });
          this.reload()// 需要刷新页面
        })
      });
    },
    //完工
    closeCompletionDialog(type) {
      this.completionDialog = false;
      this.$emit('editViewDataUpdate')// 需要刷新页面
      if (type == 1) {
        this.reload()// 需要刷新页面
      }
    },
    //确认完工
    closeCompletComfirmDialog(type) {
      this.completComfirmDialog = false;
      if (type == 1) {
        this.reload()// 需要刷新页面
      }
    },

    // 第一个  表格
    formatter(row, column) {
      return row.isNeedReturn == 1 ? '是' : '否'
    },
    formatter1(row, column) {
      return row.isCheck == 1 ? '是' : '否'
    },
    formatter2(row, column) {
      return row.isPast == 1 ? '是' : '否'
    },
    formatter3(row, column) {
      if (row.afterFlow == 1) {
        return "必访"
      } else if (row.afterFlow == 2) {
        return '申诉'
      } else if (row.afterFlow == 3) {
        return '挂起'
      } else if (row.afterFlow == 4) {
        return '重新完工'
      } else if (row.afterFlow == 9) {
        return '关闭'
      }

    },
    formatter4(row, column) {
      return row.offAccounting == 1 ? "是" : "否"
    },
    // 卡片事件
    //点击查看图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
      // console.log(fileList, "已上传文件")
    },
    // 上传发生变化钩子
    // 注意 :on-remove="handleimageChange"与:on-change="handleimageChange" 都绑定这个方法，这样无论是上传图片还是移除图片，都会更新图片数据列表
    handleimageChange(file, fileList) {
      this.upload_img = fileList;
      // this.upload_img.imageName=fileList.name;
      console.log(fileList, "文件状态改变时")
      console.log(file, "文件状态改变时file")
    },
  },
};
</script>
<style lang="scss" scoped>
#containt .detail-wrap .d-header {
  margin: -6px 0px 0 -12px !important;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
}

.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.header_dialog {
  border-radius: 8px !important;
  height: 800px !important;
}

el-dialog {
  border-radius: 8px !important;
  box-shadow: 0 0 24px rgb(0 0 0 / 22%) !important;
}

v::deep .el-upload .el-upload--picture-card {
  position: relative;
  left: -200px;
}

// 单选框
.radio_item {
  width: 24%;
  margin-top: 10px;
  margin-bottom: 10px !important;

  >span {
    display: inline-block;
    width: 120px;
    margin-right: 13px;
    text-align: right;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }
}

.firm {
  .el-input {
    width: 150px;
  }
}

.type_title {
  font-weight: 400;
  text-align: right;
  width: 112px;
  position: relative;
  padding: 0 10px 0 4px;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

.type_select {
  width: 120px;
  text-align: center;
}

.type_brand {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  >div {
    margin: 16px 0;
    width: 25%;
  }
}

// 备注的样式
.annotate {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

.el-textarea__inner {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

// 装图片的  大框
::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

::v-deep.el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none !important;
}

// witch 开关  标题的宽度
.el-switch__label * {
  line-height: 1;
  width: 160px !important;
  display: inline-block;
  font-weight: 400;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

// 清楚表格 默认padding
.el-table--medium .el-table__cell {
  padding: 0px 0 !important;
}

.table_item {
  .el-table__row:hover>td {
    background-color: #D4E7FF !important;
  }
}

.pic_item {

  .el-upload--picture-card {
    margin-top: 1px;
    width: 36px !important;
    height: 36px !important;
    line-height: 46px !important;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

.papers {
  margin-left: 30px;
  position: absolute;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

.btn_zdy {
  margin: 10px 0;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #2A6494 !important;
  border: 1px solid #2A6494 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #2A6494 !important;
  border: 1px solid #2A6494 !important;
}

::v-deep .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 0 0px !important;
}

// 步骤条
::v-deep .el-card__body,
.el-main {
  padding: 0px !important;
  font-size: 12px;
}

.task {
  color: #62f382;
}

.card {
  padding: 0px 5px;
  background-color: #efefef;
}

.title_icon1 {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #409EFF;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

.title_icon {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #2a6494;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

::v-deep .el-timeline-item__node {
  background-color: #ffffff !important;
  border: 1px solid #0550ef;
}

::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

.bread {
  span {
    color: rgba(86, 86, 86, 0.96) !important;
  }

  ::v-deep .el-collapse-item__content {
    padding-bottom: 0px;
    background-color: #efefef;

  }
}

.el-timeline {
  margin-top: 40px;
  margin: 0;
  list-style: none;
  margin-left: 6px;
  border: 1px solid #fbfbfb;
  padding-top: 12px;
  height: 72.5vh;
  overflow-y: scroll;
  background-color: #f2f2f2;
  padding-left: 10px !important;
}

.card_bread {
  position: relative !important;
}

::v-deep .el-tabs__content {
  overflow: visible !important;

}

#containt .detail-wrap .d-cont {
  overflow: unset !important;
}

// .el-timeline-item {
//   position: relative;
//   padding-bottom: 0px !important;
//   margin-left: 47px;
// }
.el-timeline-item[data-v-2cf56cc1] {
  position: relative;
  margin-left: 5px;
  padding-bottom: 0px !important;
}

// 滚动条样式

/* 滚动条 */
::-webkit-scrollbar {
  width: 5px;
  height: 12px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 0px;
  // background: rgba(224, 7, 7, 0.05);
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 00px;
  background: #cfcece;
}

// 步骤条 圆的位置
::v-deep .el-timeline-item__node--normal {
  left: 0px !important;
  width: 12px;
  height: 12px;
}

.el-timeline[data-v-2cf56cc1] {
  position: relative !important;
}

#containt .detail-wrap .d-cont .d-item {
  border: solid 1px #e9e9e9;
  padding: 0 12px 6px;
  position: relative !important;
}

::v-deep .el-collapse-item__arrow {
  position: absolute !important;
  top: 12px !important;
  right: 0 !important;
  font-size: 18px;
  color: #2a6494 !important;
}

.btn_zdy {
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #2A6494 !important;
  border: 1px solid #2A6494 !important;
}


::v-deep .el-collapse-item__content {
  padding-bottom: 0px !important;
}


// 本单费用位置
.expense {
  position: absolute;
  // right: 20%;
  margin-top: 5px;
  color: #2a6494;
  font-size: 13px;
}

::v-deep .el-image__preview {
  width: 60px !important;
  height: 60px !important;
}

.pic_main {
  display: flex;
  margin-left: 75px;
  margin-top: 10px;

  .pic_item {
    display: flex;
    margin-right: 40px;

    span {
      line-height: 60px;
      font-size: 12px;
      color: rgba(86, 86, 86, 0.96);
      font-weight: 400;

    }
  }
}

// 步骤条
.el-steps--simple {
  margin: -5px 0 -5px;
}

.el-step.is-simple {
  width: 225px;
}

.audit {
  span {
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
    font-weight: 400;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

// 折叠样式对其
// .table-detail {
//   tr{
//     display:block;
//   }
// }
#containt .table-detail tbody tr th {
  display: table-cell;
  vertical-align: middle;
}

#containt .table-detail tbody tr td {

  display: table-cell;
  vertical-align: middle;
}

.title_time {
  margin-top: -13px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .span1 {
    color: #2a6494 !important;
    width: 35%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .span2 {
    margin-right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

}


// 字段之间的距离
#containt .table-detail tbody tr td {
  padding: 5px 12px;
  width: 172.2px;
  height: 27.2px !important;
  word-break: break-word;
}

.information {
  padding: 4px 10px;
  background-color: #E1F2FF;
  color: #268AEA;
  border-radius: 3px;
  margin: 0 5px;
}

#containt .table-detail tbody tr th {
  width: 7vw !important;
}

#containt .table-detail tbody tr td {
  width: 10vw !important;
  padding: 0 0 0 7px !important;
;
}

::v-deep .el-step__title {
  font-size: 11px;
  line-height: 25px;
}

#containt .detail-wrap .d-cont .d-item {
  padding: 5px 0 !important;
}

.gather .el-tab-pane {
  margin-top: 10px;
  // padding: 20px 0;

  >>>.el-tabs__active-bar {
    left: 20px !important;
  }

  .el-tabs__nav {
    margin-left: 20px !important;
  }
}

#containt .title b {
  margin-left: 0px !important;
}

::v-deep .product th:after {
  display: none !important;
}

::v-deep .product td {
  padding: 5px 0 !important;

}

::v-deep .vxe-table--render-default .vxe-cell {
  text-align: left !important;
}

.el-image {
  border: dashed 1px #e2e2e2;
  margin-right: 20px;
}

.undergo {
  ::v-deep .el-card.is-always-shadow {
    background-color: #f2f2f2;
    position: relative;
  }

  .el-timeline {
    background-color: #fff;
    padding-left: 10px !important;
    height: 100% !important;
  }

  .el-image {
    width: 60px !important;
    height: 60px !important;
  }

}

.title_p {
  margin-top: 0;
  line-height: 28px;
  font-size: 16px;
  // width: 90px;
  white-space: nowrap;
  font-weight: 600;
  /* margin-right: 84px; */
  vertical-align: middle;
  color: #2a6494;
  position: relative;
  z-index: 2;
  background: rgba(42, 100, 148, 0.16);
  /* margin-left: -12px; */
  padding-left: 12px;
  padding-right: 14px;
  border-radius: 0 28px 28px 0;
}

.Instructions {
  text-decoration: underline;
  color: #2a6494;
  margin-left: 5px;
}

::v-deep .el-image {
  width: 60px !important;
  height: 60px !important;
}

.more {
  position: absolute;
  margin-top: 5px;
  right: 10%;
  color: #2a6494;
  font-size: 13px;
}</style>
